import { Card, CardSection, CardFile, CardFileState, CardRow, CardRowState, CardGetMode, CardTask } from "tessa/cards";
import { IControlViewModel, ICardModel, ICardEditorModel, ICardUIExtensionContext } from "tessa/ui/cards";
import { DotNetType, createTypedField, Visibility, Guid, DbType, TypedField } from "tessa/platform";
import { ButtonViewModel, GridViewModel, GridRowAction, CheckBoxViewModel, TextBoxViewModel } from "tessa/ui/cards/controls";
import { UIContext, IUIContext, showNotEmpty, showError, LoadingOverlay } from "tessa/ui";
import { CdFdTaskTypes } from "../CdFdTaskTypes";
import { IStorage, ArrayStorage } from "tessa/platform/storage";
import { CardRequest, CardService, CardGetRequest, CardGetFileContentRequest } from "tessa/cards/service";
import { CdRequestTypes } from "../CdRequestTypes";
import { IFile } from "tessa/files";
import { CdFileTypes } from "../CdFileTypes";
import { CdUIHelper } from "../../UI/CdUIHelper";
import { ChFileCategories } from "src/pkScripts/Helpers/ChFileCategories";
import { CdDocStates } from "../CdDocStates";
import { CdExecutiveDocumentationKinds } from "../CdExecutiveDocumentationKinds";
import { CdExtensionHelper } from "../CdExtensionHelper";
import { CdTaskTypes } from "../CdTaskTypes";
import { CdFdProcessHelper } from "../CdFdProcessHelper";
import { ValidationResultType } from "tessa/platform/validation";
import { ApproversRoleID } from "../Dictionaries/ApproversRoleID";
import { CdExecutiveDocumentationSharedHelper } from "./CdExecutiveDocumentationSharedHelper";
import { PkRequestTypes } from "src/pkScripts/Helpers/PkRequestTypes";
import { RequestRoleTypes } from "../Dictionaries/RequestRoleTypes";
import { number } from "prop-types";
import { CdGeneralDocumentationClientHelper, InvalidApprovers, RoleApprovers, FillMatching, Objects } from './CdGeneralDocumentationClientHelper';
import { EdKinds, ResidentalComplexes } from "../CdEdTypes";
import { ItdDocumentStates } from "../Dictionaries/ItdStates";
import { openCard, showViewsDialog } from "tessa/ui/uiHost";
import { equalsCriteriaOperator, isFalseCriteriaOperator, ViewParameterMetadata } from "tessa/views/metadata";
import { RequestParameterBuilder } from "tessa/views";
import { CdCommonHelper } from "../CdCommonHelper";
import { isNullOrUndefined } from "util";
import { ChContextRoles } from "src/pkScripts/Helpers/ChContextRoles";

let ruleForWriteSROInfo = [{ RoleID: -1, SpecNumber: false, SRODate: false, SRONumber: false }];


export class CdExecutiveDocumentationClientHelper extends CdGeneralDocumentationClientHelper {

  /** Логика кнопок */
  public static ButtonLogic(card: Card, model: ICardModel) {
    this.FileTemplateButtonLogic(card, model);
    this.FileForPrintButtonLogic(card, model);
  }

  /** Проверка после завершении задания */
  public static async CheckFieldsAfterTaskComplete(context: ICardUIExtensionContext, tasks: ArrayStorage<CardTask>) {
    let deletedTaskIndex = tasks.findIndex(x => x.state === CardRowState.Deleted);
    if (deletedTaskIndex >= 0) {
      let checkAddedFiles: boolean = await this.CheckAddedFiles(context, 1);
      let checkAddNewMatchingRoles: boolean = this.CheckAddNewMatchingRoles(context, 'PkExecutiveDocumentationMatching', 'PkExecutiveDocumentationRoles');

      if (!checkAddedFiles ||
        !checkAddNewMatchingRoles
      ) {
        context.cancel = true;
        return;
      }
    }

    deletedTaskIndex = tasks.findIndex(x =>
      x.state === CardRowState.Deleted &&
      (x.typeId === CdFdTaskTypes.PkExecutiveDocumentationInitializingTypeID.toLowerCase() ||
        x.typeId === CdFdTaskTypes.PkExecutiveDocumentationToReworkTypeID.toLowerCase()) &&
      (x.optionId === CdFdProcessHelper.SendForResubscription.toLowerCase() ||
        x.optionId === CdFdProcessHelper.ForApproval.toLowerCase()));
    let deletedArchiveTaskIndex = tasks.findIndex(x =>
      x.state === CardRowState.Deleted &&
      x.typeId === CdFdTaskTypes.PkFdInArchiveTypeID.toLowerCase() &&
      x.optionId === CdFdProcessHelper.ToArchive.toLowerCase());
    if (deletedTaskIndex >= 0) {


      let checkContentFile: boolean = await CdUIHelper.CheckContentFileAsync(context.model.card);
      let checkApprovers: boolean = this.CheckApprovers(context);

      if (!checkContentFile) {
        context.cancel = true;
        return;
      }

      let roles = CdExecutiveDocumentationSharedHelper.GetRoles().map(x => x.IntID);
      roles.push(RequestRoleTypes.PTOEngineer);
      roles.push(RequestRoleTypes.ASEngineer);

      var approvers = await this.GetApproversEd(context.model.card, roles);
      if (approvers!.length > 0) {
        let invalidApprovers = await this.GetInvalidApprovers(context.model.card, approvers, 'PkExecutiveDocumentationMatching', 'PkExecutiveDocumentationRoles');
        if (invalidApprovers!.length > 0) {
          let result = await this.ConfirmApproversChangesDialog(invalidApprovers as InvalidApprovers<number>[])
          if (result == undefined) {
            context.cancel = true;
            return;
          }
          else if (result as boolean == false) {
            context.cancel = true;
            this.SetApprovers(context.uiContext!.cardEditor!.cardModel!.card, roles.filter(x => (invalidApprovers as InvalidApprovers<number>[]).findIndex(ia => ia.RoleID == x) != -1)
              , approvers
              , 'PkExecutiveDocumentationMatching', 'PkExecutiveDocumentationRoles')

            return;
          }

        }
      }

      if (!checkApprovers) {
        context.cancel = true;
        return;
      }


    } else if (deletedArchiveTaskIndex >= 0) {
      let edmSection = context.model.card.sections.tryGet('PkExecutiveDocumentationMatching');
      if (edmSection) {
        let cnmRow = edmSection.rows.find(x =>
          x.has('RoleID') &&
          x.tryGet('RoleID') === ApproversRoleID.Contractor &&
          x.has('LegalEntityID') &&
          x.tryGet('LegalEntityID') !== null &&
          x.tryGet('LegalEntityID') !== undefined &&
          x.tryGet('LegalEntityID') !== '00000000-0000-0000-0000-000000000000');
        if (!cnmRow) {
          let orgnzForFill = '';
          let roleNameRow = edmSection.rows.find(x =>
            x.has('RoleID') &&
            x.tryGet('RoleID') === ApproversRoleID.Contractor);
          if (roleNameRow) {
            orgnzForFill += '\n' + roleNameRow.tryGet('RoleName');
            context.validationResult.add(ValidationResultType.Error, 'Необходимо заполнить юридическое лицо:' + orgnzForFill);
            context.cancel = true;
            return;
          }
        }
      }
    }

    // TES-8694 проверка подписания файлов в категории Паспорта и сертификаты
    // Статус: На подписании Подрядчика; Тип задачи: Подписание​ ИД; Вариант завершения: Подписать
    if (context.card.tasks.some(x => x.typeId == CdFdTaskTypes.PkSignExecutiveDocumentationAgreementWithAgreementorTypeID && x.optionId == CdFdProcessHelper.Sign)) {
      let dciSection: CardSection | undefined = context.card.sections.tryGet('PkDocumentCommonInfo');
      let stateID: number | undefined = dciSection?.fields.tryGet('StateID');
      if (stateID && stateID == CdDocStates.OnSigningContractor.id) {
        if (!await this.CheckPassportsAndCertificatessSignaturesAsync(context.model.card)) {
          context.validationResult.add(
            ValidationResultType.Error,
            'Необходимо подписать все файлы в категории \"' + ChFileCategories.PassportsAndCertificates.caption + '\". Файлы должны быть подписаны сотрудником в роли \"Автор документа\" или \"Подрядчик\".');
          context.cancel = true;
          return;
        }
      }
    }

    //return;
    await this.SignFilesAsync(context, tasks, CdExecutiveDocumentationSharedHelper.ApproverTaskStoreInfo.TaskSignTypesList);
  }

  public static async CheckPassportsAndCertificatessSignaturesAsync(card: Card) {

    const contextRoleIDs: TypedField<DotNetType.Guid>[] = [];
    contextRoleIDs.push(createTypedField(ChContextRoles.AuthorId, DotNetType.Guid));
    contextRoleIDs.push(createTypedField(ChContextRoles.Contractor, DotNetType.Guid));

    const fileVersionIDs: TypedField<DotNetType.Guid>[] = [];
    
    const files = card.files.filter(f => f.categoryId === ChFileCategories.PassportsAndCertificates.id)
    for (const file of files) {
      fileVersionIDs.push(createTypedField(file.lastVersion?.rowId, DotNetType.Guid));
    }
    
    const checkRequest = new CardRequest();
    checkRequest.requestType = CdRequestTypes.CdCheckFileSignaturesBySignerRoles;
    checkRequest.info["CardID"] = createTypedField(card?.id, DotNetType.Guid);
    checkRequest.info["FileVersionIDs"] = fileVersionIDs;
    checkRequest.info["SignerInContextRoleIDs"] = contextRoleIDs;

    const response = await CardService.instance.request(checkRequest);
    if (!response.validationResult.isSuccessful)
      return false;

    let error = response.info.Error?.$value;
    if (error) {
      await showError(error);
      return false;
    }

    let res: boolean = response.info.Result.$value;
    return res;
  }

  public static AddApproverEdFieldChanged(row: CardRow, model: ICardModel, edmSection: CardSection) {
    row.fieldChanged.add(() => {

      if (!row.tryGet("RoleKCKExternalID")
        || !row.tryGet("RoleKCKID")
        || !row.tryGet("RoleEntityID")
        || !row.tryGet("RoleEntityName")
        || !row.tryGet("RoleKCKName")) return;
      {
        let matchingRowID = row.tryGetField('MatchingRowID');
        if (matchingRowID) {
          this.FillLegalEntityField(row, model.card, matchingRowID.$value, 'PkExecutiveDocumentationMatching');
          if (row.has('RoleKCKExternalID') &&
            row.tryGet('RoleKCKExternalID') !== null &&
            edmSection) {
            let edmRow = edmSection.rows.find(x => matchingRowID !== null && matchingRowID !== undefined && x.rowId.toLowerCase() === matchingRowID.$value.toLowerCase());
            let extID: number | null = row.tryGet('RoleKCKExternalID');
            if (extID && edmRow) this.FillSROInfo(edmRow, extID);
          }
        }
      }
    })
  }

  /** Заполнение юридического лица в ТЧ #25698 */
  public static FillLegalEntity(model: ICardModel) {

    let edrSection = model.card.sections.tryGet('PkExecutiveDocumentationRoles');
    let edmSection = model.card.sections.tryGet('PkExecutiveDocumentationMatching');
    if (!edrSection || !edmSection) return;

    edrSection.rows.forEach(r => {
      this.AddApproverEdFieldChanged(r, model, edmSection!);
    });

    edrSection.rows.collectionChanged.add(e => {
      if (e.added.length > 0) {
        let row = e.added[0];
        this.AddApproverEdFieldChanged(row, model, edmSection!);
      }
    });

    let matchingControlViewModel: IControlViewModel | undefined = model.controls.get('Matching');
    if (matchingControlViewModel) {
      let controlViewModel = matchingControlViewModel as GridViewModel | null;
      if (controlViewModel) {
        controlViewModel.rowInitializing.add(e => {
          e.row.fieldChanged.add(async e1 => {
            if (e1.fieldName === 'LegalEntityExternalID') {
              let row = e.row;
              if (row.has('OrderSRONumber')) row.set('OrderSRONumber', createTypedField(null, DotNetType.String));
              if (row.has('OrderSRODate')) row.set('OrderSRODate', createTypedField(null, DotNetType.DateTime));

              if (row.has('LegalEntityExternalID') &&
                row.tryGet('LegalEntityExternalID') !== null) {
                await this.FillSROInfo(row, row.tryGet('LegalEntityExternalID'));
              }
            }
          });
        });

        controlViewModel.rowValidating.add(e => {
          let matchingRowID = e.row.rowId;
          let section = model.card.sections.get("PkExecutiveDocumentationRoles")!;

          if (!section || !matchingRowID) {
            return;
          }

          let cardRow = new CardRow();
          section.rows.forEach(r => {
            if (r.tryGet("MatchingRowID") == matchingRowID && r.state != CardRowState.Deleted) {
              cardRow = r;
            }
          });
          this.FillLegalEntityField(cardRow ?? new CardRow(), model.card, matchingRowID, "PkExecutiveDocumentationMatching");
        });
      }
    }
  }

  // Заполнить согласующих в ТЧ #22449
  public static FillApproversLogic(context: ICardUIExtensionContext) {
    const objects = context.model.controls.get('Objects') as GridViewModel;
    if (!objects) return;
    let card: Card = context.model.card;
    let objSection: CardSection | undefined = card.sections.tryGet('PkObjectList');
    let edRolesSection: CardSection | undefined = card.sections.tryGet('PkExecutiveDocumentationRoles');
    let edMatchingSection: CardSection | undefined = card.sections.tryGet('PkExecutiveDocumentationMatching');
    if (!objSection || !edRolesSection || !edMatchingSection) return;
    objects.rowInitializing.add(e => {
      e.row.fieldChanged.add(e2 => {

        if (!e || !objSection) return;

        if (e2.fieldName == "ResidentialComplexID") {
          this.CheckMatchingByResidentalComplex(card, e2.fieldValue);
        }

        if (e2.fieldName == "ObjectID") {
          {
            this.FillApproversEd(card);
          }
        }
      });
    });
  }

  private static CheckMatchingByResidentalComplex(card: Card, residentalComplexID: string | undefined) {
    // TES-6561 в таблице согласования должна быть строка "Представитель Застройщика" (RoleID = 9) только для объектов по ЖК Holland Park
    // Удаляем строчку в PkExecutiveDocumentationMatching, где RoleID = 9
    let pkEdMatchingSection = card.sections.tryGet('PkExecutiveDocumentationMatching');

    if (!isNullOrUndefined(pkEdMatchingSection)) {
      for (let i = pkEdMatchingSection.rows.length - 1; i >= 0; i--) {
        let row = pkEdMatchingSection!.rows[i];

        if (row.get("RoleID") == ApproversRoleID.DevelopersRepresentative) {
          if (row.state === CardRowState.Inserted) {
            pkEdMatchingSection.rows.remove(row);
          }
          row.state = CardRowState.Deleted;
        }
      }
    }

    // Если ЖК Holland Park, то  добавляем строчку  "Представитель Застройщика" (RoleID = 9)
    if (!isNullOrUndefined(residentalComplexID) && residentalComplexID.toLowerCase() == ResidentalComplexes.HollandPark.toLowerCase()) {
      let row = new CardRow();
      row.state = CardRowState.Inserted;
      row.rowId = Guid.newGuid();
      row.set("RoleID", ApproversRoleID.DevelopersRepresentative, DotNetType.Int32);
      row.set("RoleName", "Представитель Застройщика", DotNetType.String);
      row.set("LegalEntityID", null);
      row.set("LegalEntityExternalID", null);
      row.set("LegalEntityName", null);
      row.set("Order", 8, DotNetType.Int32);;
      pkEdMatchingSection?.rows.push(row);
      pkEdMatchingSection?.rows.sort((a, b) => a.get("Order") - b.get("Order"))
    }
  }

  private static async FillApproversEd(card: Card) {
    let roles = CdExecutiveDocumentationSharedHelper.GetRoles().map(x => x.IntID);
    roles.push(RequestRoleTypes.PTOEngineer);
    roles.push(RequestRoleTypes.ASEngineer);

    let objSection: CardSection | undefined = card.sections.tryGet('PkObjectList');
    if (!objSection) return;

    this.GetApproversEd(card.clone(), roles).then(
      (result => this.SetApprovers(card, roles, result, 'PkExecutiveDocumentationMatching', 'PkExecutiveDocumentationRoles'))
    );
  }

  private static async GetApproversEd(card: Card, roles: number[]) {
    let roleApprovers: RoleApprovers<number>[] = [];
    let objectList = CdExtensionHelper.GetObjectListFromPkObjectListSection(card);
    if (!objectList || objectList.length == 0) return;

    try {
      const request = new CardRequest();
      request.requestType = PkRequestTypes.GetApproversByObjects;
      let objects = objectList.map(x => (x.ID as any).$value as string).join(";");
      request.info["Objects"] = createTypedField(objects, DotNetType.String);

      const response = await CardService.instance.request(request);
      await showNotEmpty(response.validationResult.build());
      if (!response.validationResult.isSuccessful) {
        return null;
      }

      roles.forEach(role => {
        if (!response.info!['EdApproversID' + role] || !response.info!['EdApproversID' + role].$value) return;
        let edApproversID: string[] | null = response.info!['EdApproversID' + role].$value.split(';');
        let edApproversName: string[] | null = response.info!['EdApproversName' + role].$value.split(';');
        if (!edApproversID || !edApproversName) return;
        if (edApproversID.length === 0 || edApproversID.length !== edApproversName.length) return;
        let approversList: { ID: guid, Name: string }[] = []
        for (let k = 0; k < edApproversID.length; k++) {
          if (!edApproversName[k] != null)
            approversList.push({ ID: edApproversID[k], Name: edApproversName[k] });
        }
        roleApprovers.push({
          RoleID: role
          , OrderNumber: createTypedField(response.info!['EdOrderNumber' + role].$value, DotNetType.String)
          , OrderDate: createTypedField(response.info!['EdOrderDate' + role].$value, DotNetType.DateTime)
          , Approvers: approversList
        });
      });
    }
    catch (err) {
      showError(err);
    }

    let edMatchingSection: CardSection | undefined = card.sections.tryGet('PkExecutiveDocumentationMatching');
    if (!edMatchingSection) return;

    // Заполнение Инженера ПТО #27647 и Инженера АН #31973
    let rowPTO = edMatchingSection.rows.findIndex(x =>
      x.has('RoleID') &&
      x.tryGet('RoleID') !== null &&
      x.tryGet('RoleID') === RequestRoleTypes.PTOEngineer);
    let rowAS = edMatchingSection.rows.findIndex(x =>
      x.has('RoleID') &&
      x.tryGet('RoleID') !== null &&
      x.tryGet('RoleID') === RequestRoleTypes.ASEngineer);

    if (!rowPTO || !rowAS) return;

    let engineersRoles: number[] = [RequestRoleTypes.PTOEngineer, RequestRoleTypes.ASEngineer]
    for (let i = 0; i < number.length; i++) {
      let roleID = engineersRoles[i];
      let row = edMatchingSection.rows.find(x =>
        x.has('RoleID') &&
        x.tryGet('RoleID') !== null &&
        x.tryGet('RoleID') === roleID);

      if (!row) continue;
      const request = new CardRequest();
      request.requestType = CdRequestTypes.GetUsersForTable;
      request.info["IdpTeamRoleExtID"] = createTypedField((roleID == RequestRoleTypes.PTOEngineer ? 47 : 46), DotNetType.Int32);
      request.info["ObjectList"] = objectList;

      const response = await CardService.instance.request(request);
      await showNotEmpty(response.validationResult.build());
      if (!response.validationResult.isSuccessful) {
        return null;
      }
      let users: [{ RoleID, RoleName }] = response.info.Users;
      let approversList: { ID: guid, Name: string }[] = []
      for (let i = 0; i < users.length; i++) {
        let userInfo = users[i];
        if (userInfo.RoleName.$value.length === 0) continue;
        approversList.push({ ID: userInfo.RoleID.$value, Name: userInfo.RoleName.$value });
      }
      let roleApprover = roleApprovers.find(x => x.RoleID == roleID);
      if (roleApprover != null)
        roleApprover.Approvers.concat(approversList);
      else
        roleApprovers.push({
          RoleID: roleID
          , OrderNumber: createTypedField(null, DotNetType.String)
          , OrderDate: createTypedField(null, DotNetType.DateTime)
          , Approvers: approversList
        });
    }
    if (await this.GetApproversLegalEntityInfo(roleApprovers) != true) return;
    return roleApprovers;
  }

  public static CheckApprovementTableOrder(context: ICardUIExtensionContext) {

    let card = context.card;
    let edmSection = card.sections.tryGet('PkExecutiveDocumentationMatching');
    if (edmSection &&
      edmSection.rows.findIndex(x =>
        x.state === CardRowState.Modified ||
        x.state === CardRowState.Inserted) >= 0) {

      let isExternalBuilder = CdUIHelper.GetUIControl<CheckBoxViewModel>(context, "isExternalBuilder");
      let eoIndex = edmSection.rows.findIndex(x =>
        x.has('RoleID') &&
        x.has('Order') &&
        x.get('RoleID') === ApproversRoleID.OperatingOrganization);
      if (eoIndex >= 0) {

        let roles = CdExecutiveDocumentationSharedHelper.GetRoles();
        let step = 0;
        let eoOrders = edmSection.rows.filter(x => x.get('RoleID') === ApproversRoleID.OperatingOrganization).map(x => x.get('Order'));
        roles.sort((a, b) => a.DefaultOrder - b.DefaultOrder);

        //сначала сортируюися в соответствии с порядком, назначенным для ЭО
        for (let i = 0; i < roles.length; i++) {
          if (roles[i].IntID === ApproversRoleID.OperatingOrganization) continue;
          while (eoOrders.findIndex(x => x == step) >= 0) step++;
          let roleIDIndex = edmSection.rows.findIndex(x =>
            x.has('RoleID') &&
            x.get('RoleID') === roles[i].IntID);
          if (roleIDIndex != -1) {
            edmSection.rows[roleIDIndex].set('Order', createTypedField(step, DotNetType.Int32));
          }
          step++;
        }

        //потом ставим заказчика в конец и редактируем порядок
        if (isExternalBuilder && isExternalBuilder.isChecked) {
          let rowCustomer = edmSection.rows.find(x => x.get('RoleID') === ApproversRoleID.Customer);
          if (rowCustomer) rowCustomer.set('Order', createTypedField(100, DotNetType.Int32));
          let step = 0;
          edmSection.rows.sort((a, b) => a.get("Order") - b.get("Order"))
          for (let i = 0; i < edmSection.rows.length; i++) {
            edmSection.rows[i].set('Order', createTypedField(step, DotNetType.Int32));
            step++;
          }
        }
      }
    }
  }

  /** Логика для сортировки таблицы #26216 */
  public static TableOrderLogic(card: Card, context: ICardUIExtensionContext) {
    let edmSection = card.sections.tryGet('PkExecutiveDocumentationMatching');

    //Доступ на редактирование пустых полей СРО и номера специалиста #35244
    let pdciSection: CardSection | undefined = card.sections.tryGet('PkDocumentCommonInfo');
    if (pdciSection) {
      let stateID: number | null | undefined = pdciSection.fields.tryGet('StateID');
      if (edmSection &&
        stateID &&
        (stateID === CdDocStates.Draft.id ||
          stateID === CdDocStates.Rework.id)) {
        ruleForWriteSROInfo = [{ RoleID: -1, SpecNumber: false, SRODate: false, SRONumber: false }];
        for (let i = 0; i < edmSection.rows.length; i++) {
          let edmRow = edmSection.rows[i];
          if (edmRow.has('RoleID')) {
            let roleID = edmRow.tryGet('RoleID');
            if (roleID) {
              let rule = { SpecNumber: false, SRODate: false, SRONumber: false };
              if (edmRow.has('SpecialistNumber') &&
                !edmRow.tryGet('SpecialistNumber'))
                rule.SpecNumber = true;
              if (edmRow.has('OrderSRODate') &&
                !edmRow.tryGet('OrderSRODate'))
                rule.SRODate = true;
              if (edmRow.has('OrderSRONumber') &&
                !edmRow.tryGet('OrderSRONumber'))
                rule.SRONumber = true;
              ruleForWriteSROInfo[ruleForWriteSROInfo.length] = { RoleID: roleID, SpecNumber: rule.SpecNumber, SRODate: rule.SRODate, SRONumber: rule.SRONumber }
            }
          }
        }

        let matchingControlViewModel: IControlViewModel | undefined = context.model.controls.get('Matching');
        if (matchingControlViewModel) {
          let controlViewModel = matchingControlViewModel as GridViewModel | null;
          if (controlViewModel) {

            controlViewModel.leftButtons.forEach(x => { x.setIsEnabled(false) });

            //кнопки добавить\удалить.
            controlViewModel.rowInvoked.add(e => {
              if (e.action === GridRowAction.Deleting) {
                if (e.row.tryGetField("RoleID")!.$value != 6 || controlViewModel!.rows.filter(x => x.row.tryGetField("RoleID")!.$value == 6).length <= 1) {
                  e.cancel = true;
                  controlViewModel!.rows.forEach(row => {
                    let order = row.row.tryGetField("Order")!.$value;
                    let eorder = e.row.tryGetField("Order")!.$value;
                    if (order && row.rowId != e.row.rowId && order >= eorder)
                      row.row.set("Order", createTypedField(order + 1, DotNetType.Int32))
                  });
                }
              }
              if (e.action === GridRowAction.Inserted) {
                let eoRoleRow = edmSection!.rows.find(x => x.tryGetField("RoleID")!.$value == 6)
                e.row.set('RoleID', createTypedField(6, DotNetType.Int32));
                e.row.set('RoleName', createTypedField(eoRoleRow!.tryGetField("RoleName")!.$value, DotNetType.String));
              }
            });

            controlViewModel.rowInitializing.add(e => {
              if (e.rowModel) {
                let row = e.row;
                if (row.has('RoleID')) {
                  let roleID = row.tryGet('RoleID');
                  let rule = ruleForWriteSROInfo.find(x => x.RoleID === roleID);
                  if (rule) {
                    if (e.rowModel.controls.has('OrderSRODate')) {
                      let orderSRODate = e.rowModel.controls.get('OrderSRODate');
                      if (orderSRODate)
                        orderSRODate.isReadOnly = !rule.SRODate;
                    }
                    if (e.rowModel.controls.has('OrderSRONumber')) {
                      let orderSRONumber = e.rowModel.controls.get('OrderSRONumber');
                      if (orderSRONumber)
                        orderSRONumber.isReadOnly = !rule.SRONumber;
                    }
                    if (e.rowModel.controls.has('SpecialistNumber')) {
                      let specialistNumber = e.rowModel.controls.get('SpecialistNumber');
                      if (specialistNumber)
                        specialistNumber.isReadOnly = !rule.SpecNumber;
                    }
                  }
                  e.row.fieldChanged.add(e2 => {
                    let fields = ['SpecialistNumber', 'OrderSRONumber', 'OrderSRODate'];
                    if (fields.findIndex(x => x === e2.fieldName) >= 0)
                      setTimeout(function () {
                        if (e.rowModel) {
                          let ruleTIndex = ruleForWriteSROInfo.findIndex(x => x.RoleID === roleID);
                          let ruleT = { RoleID: roleID, SpecNumber: true, SRODate: true, SRONumber: true };
                          if (ruleTIndex > -1) {
                            ruleT = ruleForWriteSROInfo[ruleTIndex];
                            if (e.row.has('OrderSRODate') &&
                              !e.row.tryGet('OrderSRODate'))
                              ruleT.SRODate = true;
                            if (e.row.has('OrderSRONumber') &&
                              !e.row.tryGet('OrderSRONumber'))
                              ruleT.SRONumber = true;
                            if (e.row.has('SpecialistNumber') &&
                              !e.row.tryGet('SpecialistNumber'))
                              ruleT.SpecNumber = true;
                            ruleForWriteSROInfo[ruleTIndex] = ruleT;
                          } else {
                            ruleForWriteSROInfo[ruleForWriteSROInfo.length] = ruleT;
                          }
                          if (e.rowModel.controls.has('OrderSRODate')) {
                            let orderSRODate = e.rowModel.controls.get('OrderSRODate');
                            if (orderSRODate)
                              orderSRODate.isReadOnly = !ruleT.SRODate;
                          }
                          if (e.rowModel.controls.has('OrderSRONumber')) {
                            let orderSRONumber = e.rowModel.controls.get('OrderSRONumber');
                            if (orderSRONumber)
                              orderSRONumber.isReadOnly = !ruleT.SRONumber;
                          }
                          if (e.rowModel.controls.has('SpecialistNumber')) {
                            let specialistNumber = e.rowModel.controls.get('SpecialistNumber');
                            if (specialistNumber)
                              specialistNumber.isReadOnly = !ruleT.SpecNumber;
                          }
                        }
                      }, 2000);
                  });
                }
              }
            });
          }
        }
      }
    }
  }

  /** Логика полей для формирования акта по шаблону */
  public static FieldsTemplateLogic(card: Card, model: ICardModel) {
    let ediSection = card.sections.tryGet('PkExecutiveDocumentationInfo');
    let wftSection = card.sections.tryGet('PkExecutiveDocumentationWorksForTemplate');

    // Обработка флага "РД отсутствует в архиве"
    let workTextControl: IControlViewModel | undefined = model.controls.get('WorkTextControl');
    let workRefControl: IControlViewModel | undefined = model.controls.get('WorkRefControl');
    if (workTextControl && workRefControl && ediSection) {
      let missingTechnicalDocumentation: boolean | undefined = ediSection.fields.tryGet('MissingTechnicalDocumentation');
      this.UpdateWorkControlsVisability(missingTechnicalDocumentation, workTextControl, workRefControl);

      ediSection.fields.fieldChanged.add(e => {
        if (e.fieldName === 'MissingTechnicalDocumentation') {
          missingTechnicalDocumentation = e.fieldValue;
          if (workTextControl && workRefControl)
            this.UpdateWorkControlsVisability(missingTechnicalDocumentation, workTextControl, workRefControl);
        }
      });
    }

    // Заполнение ЖК для при смене объекта
    const objects = model.controls.get('Objects') as GridViewModel;
    if (objects && ediSection && ediSection.fields.has('ResidentialComplexID')) {
      objects.rowInitializing.add(e => {
        e.row.fieldChanged.add(e1 => {
          if (e1.fieldName === 'ResidentialComplexID') {
            let residentialComplexID = e1.fieldValue as guid | undefined;
            if (residentialComplexID && ediSection) {
              ediSection.fields.set('ResidentialComplexID', createTypedField(residentialComplexID, DotNetType.Guid));
            }
          } else if (e1.fieldName === 'RegionID') {
            let regionID = e1.fieldValue as guid | undefined;
            if (regionID && ediSection) {
              ediSection.fields.set('RegionID', createTypedField(regionID, DotNetType.Guid));
            }
          }
        });
      });
    }

    // Тех документация
    if (wftSection) {
      wftSection.rows.collectionChanged.add(e => {
        if (e.added.length > 0) {
          let row: CardRow = e.added[0];
          row.fieldChanged.add(async e1 => {
            if (e1.fieldName === 'WorkTechnicalDocumentationID') {
              let tdId = e1.fieldValue;
              if (!tdId) {
                row.set('Number', createTypedField(null, DotNetType.String));
                row.set('RdDivision', createTypedField(null, DotNetType.String));
                row.set('ContractDivision', createTypedField(null, DotNetType.String));
                row.set('Version', createTypedField(null, DotNetType.String));
                return;
              }

              const request = new CardRequest();
              request.requestType = CdRequestTypes.GetRdInfo;
              request.info["CardID"] = createTypedField(tdId, DotNetType.Guid);

              const response = await CardService.instance.request(request);
              await showNotEmpty(response.validationResult.build());
              if (!response.validationResult.isSuccessful) {
                return null;
              }

              let docNumber = row.tryGetField('WorkTechnicalDocumentationFullNumber');
              let respInfo = response.info;
              if (respInfo && respInfo.ArNumber && respInfo.ArNumber.$value)
                row.set('Number', createTypedField(respInfo.ArNumber.$value, DotNetType.String));
              else if (docNumber)
                row.set('Number', createTypedField(docNumber.$value, DotNetType.String));

              if (respInfo && respInfo.RdDivision && respInfo.ContractDivision && respInfo.Version) {
                row.set('RdDivision', createTypedField(respInfo.RdDivision.$value, DotNetType.String));
                row.set('ContractDivision', createTypedField(respInfo.ContractDivision.$value, DotNetType.String));
                row.set('Version', createTypedField(respInfo.Version.$value, DotNetType.String));
              }
            }
          });
        }
      });
    }
  }

  /** Проверка файлов в ИД
  * from: 0 - ui, 1 - задание */
  public static async CheckAddedFiles(context: ICardUIExtensionContext, from: number) {
    let card: Card = context.model.card;
    let result: boolean = true;

    switch (from) {
      // Проверяемые расширения файлов
      case 0:
        const availibleFileExtensions: string[] = ['DOCX', 'DOC', 'XLSX', 'XLS', 'PDF', 'SGN'];
        for (let i = 0; i < card.files.length; i++) {
          let file = card.files[i];
          if (file.state === CardFileState.Deleted ||
            file.state === CardFileState.None ||
            file.name.toLowerCase() === 'история согласования.html') continue;
          let correctFile: boolean = false;
          for (let j = 0; j < availibleFileExtensions.length; j++) {
            let ext = availibleFileExtensions[j];
            if (file.name.toUpperCase().indexOf('.' + ext) !== -1) {
              correctFile = true;
              break;
            }
          }
          if (!correctFile) {
            showError('Приложенные файлы должены быть в формате: ' + availibleFileExtensions.join(', '));
            context.cancel = true;
            return true;
          }
        }
        break;
      // Проверка наличия файлов в категориях
      case 1:
        // Проверка, что все файлы сохранены
        if (context.card.tasks.findIndex(x =>
          x.state === CardRowState.Deleted &&
          (x.typeId === CdFdTaskTypes.PkExecutiveDocumentationInitializingTypeID.toLowerCase() ||
            x.typeId === CdFdTaskTypes.PkExecutiveDocumentationToReworkTypeID.toLowerCase())) >= 0 &&
          card.files.findIndex(x =>
            x.state === CardFileState.Inserted ||
            x.state === CardFileState.Modified ||
            x.state === CardFileState.ModifiedAndReplaced ||
            x.state === CardFileState.Replaced) >= 0) {
          context.validationResult.add(ValidationResultType.Error, 'Пожалуйста, сохраните карточку перед тем как продолжить.');
          return false;
        }
        // Проверка файлов в категориях
        let ediSection: CardSection | undefined = card.sections.tryGet('PkExecutiveDocumentationInfo');
        let pdciSection: CardSection | undefined = card.sections.tryGet('PkDocumentCommonInfo');
        if (!ediSection || !pdciSection) break;
        let edTypeID = ediSection.fields.tryGet('EDTypeID');
        let stateID: number | null | undefined = pdciSection.fields.tryGet('StateID');
        if (!edTypeID || !stateID) break;
        for (let i = 0; i < context.card.tasks.length; i++) {
          let task = context.card.tasks[i];
          if (task.state !== CardRowState.Deleted ||
            !task.optionId) continue;

          let isInitialization: boolean =
            task.typeId.toLowerCase() === CdTaskTypes.PkExecutiveDocumentationInitializingTypeID.toLowerCase() &&
            task.optionId.toLowerCase() === CdFdProcessHelper.ForApproval.toLowerCase() ||
            task.typeId.toLowerCase() === CdFdTaskTypes.PkSignExecutiveDocumentationInitializingTypeID.toLowerCase() &&
            task.optionId.toLowerCase() === CdFdProcessHelper.PkSendForSigning.toLowerCase();
          let isRework: boolean =
            task.typeId.toLowerCase() === CdFdTaskTypes.PkExecutiveDocumentationToReworkTypeID.toLowerCase() &&
            task.optionId.toLowerCase() === CdFdProcessHelper.SendForResubscription.toLowerCase();
          let isGP: boolean =
            (task.typeId.toLowerCase() === CdFdTaskTypes.PkExecutiveDocumentationAgreementWithAgreementorTypeID.toLowerCase() ||
              task.typeId.toLowerCase() === CdFdTaskTypes.PkSignExecutiveDocumentationAgreementWithAgreementorTypeID.toLowerCase()) &&
            (task.optionId.toLowerCase() === CdFdProcessHelper.Approve.toLowerCase() ||
              task.optionId.toLowerCase() === CdFdProcessHelper.Sign.toLowerCase()) &&
            (stateID === CdDocStates.OnApprovalGP.id ||
              stateID === CdDocStates.OnSigningGP.id);
          let isArchive: boolean =
            task.typeId.toLowerCase() === CdFdTaskTypes.PkFdInArchiveTypeID.toLowerCase() &&
            task.optionId.toLowerCase() === CdFdProcessHelper.ToArchive.toLowerCase();

          let categoryList: string[] = [];
          if (isInitialization || isGP || isArchive || isRework) {
            // Если передача в архив, и Вид ИД - Журналы, проверяем файлы в 2. Журналы
            let edKindID = ediSection.fields.tryGet('EDKindNewID');
            if (isArchive &&
              edKindID &&
              edKindID.toLowerCase() === EdKinds.Journal) {
              categoryList[0] = ChFileCategories.Journal.id as string;
            }
            else {
              categoryList[0] = ChFileCategories.DocumentID.id as string;
            }

            const edTypeRequest = new CardGetRequest();
            edTypeRequest.getMode = CardGetMode.ReadOnly;
            edTypeRequest.cardId = edTypeID;
            const edTypeResponse = await CardService.instance.get(edTypeRequest);
            const edTypeCard = edTypeResponse.card;
            const edtSection = edTypeCard.sections.tryGet('PkExecutiveDocumentationTypes');
            const efcSection = edTypeCard.sections.tryGet('PkExecutiveDocumentationFileCategories');
            if (edtSection && efcSection) {
              let workTypeID = edtSection.fields.tryGet('PkWorkTypeID');
              if (workTypeID && efcSection.rows.length > 0) {
                for (let j = 0; j < efcSection.rows.length; j++) {
                  let categoryRow = efcSection.rows[j];
                  let categoryID: string | null | undefined = categoryRow.tryGet('CategorieID');
                  if (categoryID && categoryList.findIndex(x => x === categoryID))
                    categoryList[categoryList.length] = categoryID;
                }
              }
            }
            for (let j = 0; j < categoryList.length; j++) {
              let categoryId = categoryList[j];
              if ((isInitialization || isRework) &&

                categoryId === ChFileCategories.LaboratoryTests.id!.toLowerCase())
                continue;

              let fileIndex = card.files.findIndex(x =>
                x.categoryId !== null &&
                x.categoryId.toLowerCase() === categoryId.toLowerCase());
              if (fileIndex === -1) {
                let category = ChFileCategories.FileCategories.find(x => x.id === categoryId);
                if (category)
                  context.validationResult.add(ValidationResultType.Error, 'Загрузите файл в категорию "' + category.caption + '"');
                result = false;
                break;
              }
            }
          }
        }
        break;
    }

    return result;
  }

  /** Логика обычных полей */
  public static FieldLogic(card: Card, model: ICardModel) {
    let ediSection = card.sections.tryGet('PkExecutiveDocumentationInfo');
    let polSection = card.sections.tryGet('PkObjectList');
    // Отметить флажки ЗОС и РВЭ
    if (!ediSection) return;
    ediSection.fields.fieldChanged.add(async e => {
      if (e.fieldName === 'EDTypeID') {
        if (ediSection && ediSection.fields.has('isZOS') && ediSection.fields.has('isRVE')) {
          let edTypeID = e.fieldValue as guid | null | undefined;
          if (edTypeID) {
            const edTypeRequest = new CardGetRequest();
            edTypeRequest.getMode = CardGetMode.ReadOnly;
            edTypeRequest.cardId = edTypeID;
            const edTypeResponse = await CardService.instance.get(edTypeRequest);
            if (!edTypeResponse.validationResult.isSuccessful) {
              return;
            }
            const edTypeCard = edTypeResponse.card;
            let edTypeSection = edTypeCard.sections.tryGet('PkExecutiveDocumentationTypes');
            if (edTypeSection && edTypeSection.fields.has('isZOS') && edTypeSection.fields.has('isRVE')) {
              ediSection.fields.set('isZOS', createTypedField(edTypeSection.fields.tryGet('isZOS'), DotNetType.Boolean));
              ediSection.fields.set('isRVE', createTypedField(edTypeSection.fields.tryGet('isRVE'), DotNetType.Boolean));
            }
          } else {
            ediSection.fields.set('isZOS', createTypedField(false, DotNetType.Boolean));
            ediSection.fields.set('isRVE', createTypedField(false, DotNetType.Boolean));
          }
        }
      }
    });

    // Заполнение Признака при изменении Раздела
    if (!ediSection) return;
    ediSection.fields.fieldChanged.add(async e => {
      if (e.fieldName === 'SectionID') {
        if (ediSection && ediSection.fields.has('FeatureID')) {

          // Очистим поле "признак"
          ediSection.fields.set('FeatureID', null);
          ediSection.fields.set('FeatureName', null);

          let edSectionID = e.fieldValue as guid | null | undefined;
          if (edSectionID) {
            const edSectionRequest = new CardGetRequest();
            edSectionRequest.getMode = CardGetMode.ReadOnly;
            edSectionRequest.cardId = edSectionID;
            const edSectionResponse = await CardService.instance.get(edSectionRequest);
            if (!edSectionResponse.validationResult.isSuccessful) {
              return;
            }
            const edSectionCard = edSectionResponse.card;
            let edSectionSection = edSectionCard.sections.tryGet('CdSection');
            if (edSectionSection &&
              edSectionSection.fields.has('DefaultFeatureID') &&
              edSectionSection.fields.tryGet('DefaultFeatureID') != null) {
              ediSection.fields.set('FeatureID', createTypedField(edSectionSection.fields.tryGet('DefaultFeatureID'), DotNetType.Guid));
              ediSection.fields.set('FeatureName', createTypedField(edSectionSection.fields.tryGet('DefaultFeatureName'), DotNetType.String));
            } else {
              ediSection.fields.set('FeatureID', null);
              ediSection.fields.set('FeatureName', null);
            }
          }
        }
      }
    });

    // Проверка и заполнение ЖК и региона при открытии карточки
    if (ediSection && polSection &&
      ediSection.fields.has('ResidentialComplexID') &&
      ediSection.fields.has('RegionID') &&
      (ediSection.fields.tryGet('ResidentialComplexID') === null ||
        ediSection.fields.tryGet('RegionID') === null)) {
      // ЖК
      if (ediSection.fields.tryGet('ResidentialComplexID') === null) {
        let residentialComplexRow = polSection.rows.find(x =>
          x.has('ResidentialComplexID') &&
          x.tryGet('ResidentialComplexID') !== null);
        if (residentialComplexRow)
          ediSection.fields.rawSet('ResidentialComplexID', createTypedField(residentialComplexRow.get('ResidentialComplexID'), DotNetType.Guid));
      }
      // Регион
      if (ediSection.fields.tryGet('RegionID') === null) {
        let regionRow = polSection.rows.find(x =>
          x.has('RegionID') &&
          x.tryGet('RegionID') !== null);
        if (regionRow)
          ediSection.fields.rawSet('RegionID', createTypedField(regionRow.get('RegionID'), DotNetType.Guid));
      }
    }

    // Предзаполнение проекта при добавлении нового объекта
    let objects: IControlViewModel | undefined = model.controls.get('Objects');
    if (objects) {
      let controlViewModel = objects as GridViewModel | null;
      if (controlViewModel) {
        controlViewModel.rowInvoked.add(async e => {
          if (polSection && polSection.rows.length > 1 && e.action === GridRowAction.Inserted) {
            let newRow = e.row;
            let oldRow = polSection.rows.find(x =>
              x.rowId !== newRow.rowId);
            if (oldRow &&
              oldRow.has('ResidentialComplexID') &&
              oldRow.tryGet('ResidentialComplexID') &&
              oldRow.has('ResidentialComplexName') &&
              oldRow.tryGet('ResidentialComplexName')) {
              let residentialComplexID = oldRow.get('ResidentialComplexID') as guid;
              let residentialComplexName = oldRow.get('ResidentialComplexName') as string;
              newRow.set('ResidentialComplexID', createTypedField(residentialComplexID, DotNetType.Guid));
              newRow.set('ResidentialComplexName', createTypedField(residentialComplexName, DotNetType.String));
            }
            if (oldRow &&
              oldRow.has('ProjectID') &&
              oldRow.tryGet('ProjectID') &&
              oldRow.has('ProjectName') &&
              oldRow.tryGet('ProjectName')) {
              let projectID = oldRow.get('ProjectID') as guid;
              let projectName = oldRow.get('ProjectName') as string;
              newRow.set('ProjectID', createTypedField(projectID, DotNetType.Guid));
              newRow.set('ProjectName', createTypedField(projectName, DotNetType.String));
            }
          }
        });
      }
    }
  }

  public static FieldsExecutiveSchemeTable(card: Card) {
    let pesfed = card.sections.get("PkExecutiveSchemesForED");
    if (pesfed == null) {
      return;
    }
    // Тех документация
    if (pesfed) {
      pesfed.rows.collectionChanged.add(e => {
        if (e.added.length > 0) {
          let row: CardRow = e.added[0];
          row.fieldChanged.add(async e1 => {
            if (e1.fieldName === 'ExecutiveSchemeID') {
              let tdId = e1.fieldValue;
              if (!tdId) {
                row.set('Number', createTypedField(null, DotNetType.String));
                row.set('Author', createTypedField(null, DotNetType.String));
                row.set('CreationDate', createTypedField(null, DotNetType.DateTime));
                return;
              }

              const request = new CardRequest();
              request.requestType = CdRequestTypes.CdGetSystemInfo;
              request.info["CardId"] = createTypedField(tdId, DotNetType.Guid);

              const response = await CardService.instance.request(request);
              await showNotEmpty(response.validationResult.build());
              if (!response.validationResult.isSuccessful) {
                return null;
              }

              let respInfo = response.info;
              if (respInfo && respInfo.SecondaryFullNumber && respInfo.SecondaryFullNumber.$value)
                row.set('Number', createTypedField(respInfo.SecondaryFullNumber.$value, DotNetType.String));

              if (respInfo && respInfo.AuthorName) {
                row.set('Author', createTypedField(respInfo.AuthorName.$value, DotNetType.String));
              }
              if (respInfo && respInfo.CreationDate) {
                row.set('CreationDate', createTypedField(respInfo.CreationDate.$value, DotNetType.DateTime));
              }
            }
          });
        }
      });
    }
  }

  public static SaveCardToUpdateFiles(context: ICardUIExtensionContext) {
    LoadingOverlay.instance.show(async () => {
      let editor = context.uiContext.cardEditor;
      editor!.saveCard(context.uiContext);
    });
  }

  public static ExecutiveSchemeForEdControlLogic(card: Card, model: ICardModel, context: ICardUIExtensionContext) {
    let tableExecutiveSchemesForEd = model.controls.get("ExecutiveSchemesForEdTable");
    let pedi = card.sections.get("PkExecutiveDocumentationInfo");
    if (pedi == null) {
      return;
    }

    const tableExecutiveSchemesForEdGvm = tableExecutiveSchemesForEd as GridViewModel;
    if (tableExecutiveSchemesForEdGvm != null) {
      tableExecutiveSchemesForEdGvm.rowEditorClosed.add(e => {
        if (e.action == GridRowAction.Inserted &&
          card.sections.get('PkExecutiveSchemesForED')?.rows.find(x =>
            x.state == CardRowState.Inserted &&
            x.rowId == e.row.rowId) != undefined &&
          e.cancel != true)
          this.SaveCardToUpdateFiles(context);
      });
    }

    let kindId = pedi.fields.get("EDKindNewID");
    tableExecutiveSchemesForEd!.controlVisibility = (kindId == CdExecutiveDocumentationKinds.ActOfExaminationOfResponsibleStructures
      || kindId == CdExecutiveDocumentationKinds.ActOfIntermediateExaminationOfResponsibleStructures
      || kindId == CdExecutiveDocumentationKinds.ActOfExaminationOfHiddenWorks) ? Visibility.Visible : Visibility.Collapsed;

    pedi.fields.fieldChanged.add(async e => {
      if (e.fieldName == "EDKindNewID") {

        if (e.fieldValue == CdExecutiveDocumentationKinds.ActOfExaminationOfResponsibleStructures
          || e.fieldValue == CdExecutiveDocumentationKinds.ActOfIntermediateExaminationOfResponsibleStructures
          || e.fieldValue == CdExecutiveDocumentationKinds.ActOfExaminationOfHiddenWorks) {
          tableExecutiveSchemesForEd!.controlVisibility = Visibility.Visible;
        }
        else {
          tableExecutiveSchemesForEd!.controlVisibility = Visibility.Collapsed;
          CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems2(card, "PkExecutiveSchemesForED");
        }
      }
    });
  }

  public static FieldsHiddenWorksLogic(card: Card, model: ICardModel, context: ICardUIExtensionContext) {
    if (card.sections.has("PkExecutiveDocumentationInfo")) {
      let needToCopy = model.controls.get("NeedToCopy");
      let copiedFrom = model.controls.get("CopiedFrom");
      let hiddenWorkTable = model.controls.get("HiddenWorkTable");
      let missingHiddenWorks = model.controls.get("MissingHiddenWorks");
      let permittedFullLoad = model.controls.get("PermittedFullLoad");
      let permittedEmployStructures = model.controls.get("PermittedEmployStructures");
      let permittedEmployStructuresWithLoad = model.controls.get("PermittedEmployStructuresWithLoad");
      let pedi = card.sections.get("PkExecutiveDocumentationInfo");

      if (pedi == null || needToCopy == null
        || hiddenWorkTable == null || copiedFrom == null
        || missingHiddenWorks == null || permittedFullLoad == null
        || permittedEmployStructures == null || permittedEmployStructuresWithLoad == null) {
        return;
      }

      let kindId = pedi.fields.get("EDKindNewID");

      this.FillObjectsLikeString(card, model);

      if (kindId != null) {
        if (kindId == CdExecutiveDocumentationKinds.ActOfExaminationOfResponsibleStructures) {

          hiddenWorkTable.controlVisibility = Visibility.Visible;
          needToCopy.controlVisibility = Visibility.Visible;
          missingHiddenWorks.controlVisibility = Visibility.Visible;
          permittedFullLoad.controlVisibility = Visibility.Visible;
          permittedEmployStructures.controlVisibility = Visibility.Visible;
          permittedEmployStructuresWithLoad.controlVisibility = Visibility.Visible;
          this.UpdateVisibilityHiddenWorks(card, model);
          this.UpdateVisibilityCopiedSubject(card, model);
          this.FillActFromIntermediateAct(card, context);
        }
        else if (kindId == CdExecutiveDocumentationKinds.ActOfIntermediateExaminationOfResponsibleStructures) {

          hiddenWorkTable.controlVisibility = Visibility.Visible;
          missingHiddenWorks.controlVisibility = Visibility.Visible;
          permittedFullLoad.controlVisibility = Visibility.Visible;
          permittedEmployStructures.controlVisibility = Visibility.Visible;
          permittedEmployStructuresWithLoad.controlVisibility = Visibility.Visible;

          this.UpdateVisibilityHiddenWorks(card, model);
        }
        else {
          hiddenWorkTable.controlVisibility = Visibility.Collapsed;
          needToCopy.controlVisibility = Visibility.Collapsed;
          missingHiddenWorks.controlVisibility = Visibility.Collapsed;
          permittedFullLoad.controlVisibility = Visibility.Collapsed;
          permittedEmployStructures.controlVisibility = Visibility.Collapsed;
          permittedEmployStructuresWithLoad.controlVisibility = Visibility.Collapsed;
        }
      }

      pedi.fields.fieldChanged.add(async e => {
        if (e.fieldName == "EDKindNewID" && e.fieldValue != null) {
          if (e.fieldValue == CdExecutiveDocumentationKinds.ActOfExaminationOfResponsibleStructures) {
            hiddenWorkTable!.controlVisibility = Visibility.Visible;
            needToCopy!.controlVisibility = Visibility.Visible;
            missingHiddenWorks!.controlVisibility = Visibility.Visible;
            copiedFrom!.controlVisibility = Visibility.Visible;
            permittedFullLoad!.controlVisibility = Visibility.Visible;
            permittedEmployStructures!.controlVisibility = Visibility.Visible;
            permittedEmployStructuresWithLoad!.controlVisibility = Visibility.Visible;

            this.UpdateVisibilityHiddenWorks(card, model);
            this.UpdateVisibilityCopiedSubject(card, model);
            this.FillActFromIntermediateAct(card, context);
          }
          else if (e.fieldValue == CdExecutiveDocumentationKinds.ActOfIntermediateExaminationOfResponsibleStructures) {
            hiddenWorkTable!.controlVisibility = Visibility.Visible;
            missingHiddenWorks!.controlVisibility = Visibility.Visible;
            copiedFrom!.controlVisibility = Visibility.Collapsed;
            needToCopy!.controlVisibility = Visibility.Collapsed;
            permittedFullLoad!.controlVisibility = Visibility.Visible;
            permittedEmployStructures!.controlVisibility = Visibility.Visible;
            permittedEmployStructuresWithLoad!.controlVisibility = Visibility.Visible;

            pedi!.fields.set("isCopied", createTypedField(false, DotNetType.Boolean));
            pedi!.fields.set("CopiedFromID", null);
            pedi!.fields.set("CopiedFromSubject", null);

            this.UpdateVisibilityHiddenWorks(card, model);
          }
          else {
            hiddenWorkTable!.controlVisibility = Visibility.Collapsed;
            needToCopy!.controlVisibility = Visibility.Collapsed;
            missingHiddenWorks!.controlVisibility = Visibility.Collapsed;
            copiedFrom!.controlVisibility = Visibility.Collapsed;
            permittedFullLoad!.controlVisibility = Visibility.Collapsed;
            permittedEmployStructures!.controlVisibility = Visibility.Collapsed;
            permittedEmployStructuresWithLoad!.controlVisibility = Visibility.Collapsed;

            pedi!.fields.set("isCopied", createTypedField(false, DotNetType.Boolean));
            pedi!.fields.set("CopiedFromID", null);
            pedi!.fields.set("CopiedFromSubject", null);
          }
        }
      });
    }
  }

  /** Заполнение информации о СРО #21244 */
  private static async FillSROInfo(edmRow: CardRow, extID: number | null) {
    if (edmRow === null || extID === null) return;
    if (edmRow.has('OrderSRONumber')) edmRow.set('OrderSRONumber', createTypedField(null, DotNetType.String));
    else edmRow.set('OrderSRONumber', createTypedField(null, DotNetType.String));
    if (edmRow.has('OrderSRODate')) edmRow.set('OrderSRODate', createTypedField(null, DotNetType.DateTime));
    else edmRow.set('OrderSRODate', createTypedField(null, DotNetType.DateTime));
    if (!edmRow.has('SpecialistNumber')) edmRow.set('SpecialistNumber', createTypedField(null, DotNetType.String));

    const request = new CardRequest();
    request.requestType = CdRequestTypes.CdGetSroInfoByKCKID;
    request.info["ExtID"] = createTypedField(extID, DotNetType.Int64);

    const response = await CardService.instance.request(request);
    await showNotEmpty(response.validationResult.build());
    if (response.validationResult.isSuccessful &&
      response.info.SRONumber !== undefined &&
      response.info.SRODate !== undefined) {
      edmRow.set('OrderSRONumber', createTypedField(response.info.SRONumber.$value, DotNetType.String));
      edmRow.set('OrderSRODate', createTypedField(response.info.SRODate.$value, DotNetType.DateTime));
      if (edmRow.has('RoleID')) {
        let roleID = edmRow.tryGet('RoleID');
        if (roleID) {
          let nullSRONumber =
            response.info.SRONumber.$value === null ||
            response.info.SRONumber.$value === undefined ||
            response.info.SRONumber.$value === '';
          let nullSRODate =
            response.info.SRODate.$value === null ||
            response.info.SRODate.$value === undefined ||
            response.info.SRODate.$value === '';
          let roleIndex = ruleForWriteSROInfo.findIndex(x => x.RoleID === roleID);
          if (roleID < 0) ruleForWriteSROInfo[ruleForWriteSROInfo.length] = { RoleID: roleID, SpecNumber: false, SRODate: nullSRODate, SRONumber: nullSRONumber };
          else ruleForWriteSROInfo[roleIndex] = { RoleID: roleID, SpecNumber: ruleForWriteSROInfo[roleIndex].SpecNumber, SRODate: nullSRODate, SRONumber: nullSRONumber };
        }
      }
    }
  }

  /** Проверить таблицу согласующих */
  protected static CheckApprovers(context: ICardUIExtensionContext) {
    try {
      let card = context.model.card;

      // Проверить что в карточке имеются секции
      let ediSection = card.sections.tryGet('PkExecutiveDocumentationInfo');
      let edmSection = card.sections.tryGet('PkExecutiveDocumentationMatching');
      let edrSection = card.sections.tryGet('PkExecutiveDocumentationRoles');
      if (!ediSection || !edmSection || !edrSection) {
        return false;
      }

      // Проверить что заполнен хотя бы один согласующий
      const isAuthorSupervision: boolean | null | undefined = ediSection.fields.tryGet('isAuthorSupervision');
      const isEO: boolean | null | undefined = ediSection.fields.tryGet('isEO');
      const isExternalBuilder: boolean | null | undefined = ediSection.fields.tryGet('isExternalBuilder');
      let rolesForFill: string = '';
      let orgnzForFill: string = '';

      // TODO TIV: Нужно будет оптимизировать
      // Проверить подрядчика и заказчика
      let cnmRow = edmSection.rows.find(x =>
        x.has('RoleID') &&
        x.tryGet('RoleID') === ApproversRoleID.Contractor);
      if (!cnmRow ||
        !cnmRow.has('LegalEntityID') ||
        cnmRow.tryGet('LegalEntityID') === null ||
        cnmRow.tryGet('LegalEntityID') === undefined ||
        cnmRow.tryGet('LegalEntityID') === '00000000-0000-0000-0000-000000000000') {
        let roleNameRow = edmSection.rows.find(x =>
          x.has('RoleID') &&
          x.tryGet('RoleID') === ApproversRoleID.Contractor);
        if (roleNameRow) {
          orgnzForFill += '\n' + roleNameRow.tryGet('RoleName');
        }
      }
      let cnrRow = edrSection.rows.find(x =>
        cnmRow !== undefined &&
        x.has('MatchingRowID') &&
        x.tryGet('MatchingRowID') === cnmRow.rowId);
      if (!cnrRow) {
        let roleNameRow = edmSection.rows.find(x =>
          x.has('RoleID') &&
          x.tryGet('RoleID') === ApproversRoleID.Contractor);
        if (roleNameRow) rolesForFill += '\n' + roleNameRow.tryGet('RoleName');
      }

      if (isExternalBuilder !== null &&
        isExternalBuilder !== undefined &&
        isExternalBuilder) {
        let csmRow = edmSection.rows.find(x =>
          x.has('RoleID') &&
          x.tryGet('RoleID') === ApproversRoleID.PTOEngeneer);
        let csrRow = edrSection.rows.find(x =>
          csmRow !== undefined &&
          x.has('MatchingRowID') &&
          x.tryGet('MatchingRowID') === csmRow.rowId);
        if (!csrRow) {
          let roleNameRow = edmSection.rows.find(x =>
            x.has('RoleID') &&
            x.tryGet('RoleID') === ApproversRoleID.PTOEngeneer);
          if (roleNameRow) rolesForFill += '\n' + roleNameRow.tryGet('RoleName');
        }

        let asumRow = edmSection.rows.find(x =>
          x.has('RoleID') &&
          x.tryGet('RoleID') === ApproversRoleID.ASEngeneer);
        let asurRow = edrSection.rows.find(x =>
          asumRow !== undefined &&
          x.has('MatchingRowID') &&
          x.tryGet('MatchingRowID') === asumRow.rowId);
        if (!asurRow) {
          let roleNameRow = edmSection.rows.find(x =>
            x.has('RoleID') &&
            x.tryGet('RoleID') === ApproversRoleID.ASEngeneer);
          if (roleNameRow) rolesForFill += '\n' + roleNameRow.tryGet('RoleName');
        }
      } else {
        let csmRow = edmSection.rows.find(x =>
          x.has('RoleID') &&
          x.tryGet('RoleID') === ApproversRoleID.Customer);
        let csrRow = edrSection.rows.find(x =>
          csmRow !== undefined &&
          x.has('MatchingRowID') &&
          x.tryGet('MatchingRowID') === csmRow.rowId);
        if (!csrRow) {
          let roleNameRow = edmSection.rows.find(x =>
            x.has('RoleID') &&
            x.tryGet('RoleID') === ApproversRoleID.Customer);
          if (roleNameRow) rolesForFill += '\n' + roleNameRow.tryGet('RoleName');
        }
      }

      //#region Проверка заполненности согласующих для флажков ЭО и АН
      // Проверка АН
      let asmRow = edmSection.rows.find(x =>
        x.has('RoleID') &&
        x.tryGet('RoleID') === ApproversRoleID.AuthorSupervision);
      let asrRow = edrSection.rows.find(x =>
        asmRow !== undefined &&
        x.has('MatchingRowID') &&
        x.tryGet('MatchingRowID') === asmRow.rowId);
      if (isAuthorSupervision !== null &&
        isAuthorSupervision !== undefined &&
        !isAuthorSupervision &&
        !asrRow) {
        let roleNameRow = edmSection.rows.find(x =>
          x.has('RoleID') &&
          x.tryGet('RoleID') === ApproversRoleID.AuthorSupervision);
        if (roleNameRow) rolesForFill += '\n' + roleNameRow.tryGet('RoleName');
      }
      // Проверка ЭО
      let eomRow = edmSection.rows.find(x =>
        x.has('RoleID') &&
        x.tryGet('RoleID') === ApproversRoleID.OperatingOrganization);
      let eorRow = edrSection.rows.find(x =>
        eomRow !== undefined &&
        x.has('MatchingRowID') &&
        x.tryGet('MatchingRowID') === eomRow.rowId);
      if (isEO !== null &&
        isEO !== undefined &&
        isEO &&
        !eorRow) {
        let roleNameRow = edmSection.rows.find(x =>
          x.has('RoleID') &&
          x.tryGet('RoleID') === ApproversRoleID.OperatingOrganization);
        if (roleNameRow) rolesForFill += '\n' + roleNameRow.tryGet('RoleName');
      }

      //#endregion

      //TES-6561 Проверка заполнения "Представитель Застройщика", если ЖК HollandPark
      var drmRow = edmSection.rows.find(x =>
        x.has('RoleID') && x.state !== CardRowState.Deleted &&
        x.tryGet('RoleID') === ApproversRoleID.DevelopersRepresentative);
      var drrRow = edrSection.rows.find(x =>
        drmRow !== undefined &&
        x.has('MatchingRowID') &&
        x.tryGet('MatchingRowID') === drmRow.rowId);
      if (isNullOrUndefined(drrRow)) {
        let objectListSection = card.sections.tryGet('PkObjectList');
        if (objectListSection) {
          var hollandParkRow = objectListSection.rows.find(x =>
            x.has('ResidentialComplexID') && x.state !== CardRowState.Deleted &&
            x.tryGet('ResidentialComplexID') === ResidentalComplexes.HollandPark);
          if (hollandParkRow && drmRow) {
            rolesForFill += '\n' + drmRow.tryGet('RoleName');
          }
        }
      }

      if (edrSection.rows.length === 0) {
        context.validationResult.add(ValidationResultType.Error, 'Необходимо заполнить согласующих');
        return false;
      } else if (rolesForFill.length !== 0) {
        context.validationResult.add(ValidationResultType.Error, 'Необходимо заполнить:' + rolesForFill);
        return false;
      }
      if (orgnzForFill.length !== 0) {
        context.validationResult.add(ValidationResultType.Error, 'Необходимо заполнить юридическое лицо:' + orgnzForFill);
        return false;
      }

      // Проверить что согласующие заполнены по цепочке
      let filledApprovers: boolean[] = [false, false, false, false, false, false];
      for (let i = 0; i < edmSection.rows.length; i++) {
        let row = edmSection.rows[i];
        let edmRoleIndex = edrSection.rows.findIndex(x =>
          x.has('MatchingRowID') &&
          x.tryGet('MatchingRowID') === row.rowId);
        if (row.has('RoleID') && edmRoleIndex >= 0) {
          let roleID: number | null | undefined = row.tryGet('RoleID');
          if (!roleID || roleID >= filledApprovers.length || 0 > roleID) continue;
          filledApprovers[roleID] = true;
        }
      }

      return true;
    } catch (ex) {
      context.validationResult.add(ValidationResultType.Error, 'Ошибка при проверке согласующих.\nТекст ошибки: ' + ex.message + ' ' + ex.stack);
      return false;
    }
  }

  public static FillSpecialistNumber(card: Card) {
    if (card == null)
      return;
    const pedm = card.sections.tryGet("PkExecutiveDocumentationMatching");
    if (pedm == null) return;
    const pedr = card.sections.tryGet("PkExecutiveDocumentationRoles");
    if (pedr == null) return;

    pedr.rows.collectionChanged.add(async e => {
      if (e.added.length > 0) {
        let row = e.added[0];
        let rowId = row.get("RowID");
        if (rowId != null) {
          let userId = row.get("RoleID");
          if (userId != null) {
            const request = new CardRequest();
            request.requestType = CdRequestTypes.CdGetSpecialistnumber;
            request.info["UserID"] = createTypedField(userId, DotNetType.Guid);

            const response = await CardService.instance.request(request);
            await showNotEmpty(response.validationResult.build());
            if (!response.validationResult.isSuccessful) {
              return null;
            }
            let matchingRow = pedm.rows.find(x => x.get("RowID") === row.get("MatchingRowID"));
            if (matchingRow != null) {
              matchingRow.set("SpecialistNumber", createTypedField(response.info!.SpecialistNumber.$value, DotNetType.String));
              if (matchingRow.has('RoleID')) {
                let roleID = matchingRow.tryGet('RoleID');
                if (roleID) {
                  let roleIndex = ruleForWriteSROInfo.findIndex(x => x.RoleID === roleID);
                  let nullSpecNumber =
                    response.info!.SpecialistNumber.$value === null ||
                    response.info!.SpecialistNumber.$value === undefined ||
                    response.info!.SpecialistNumber.$value === '';
                  if (roleIndex < 0) ruleForWriteSROInfo[ruleForWriteSROInfo.length] = { RoleID: roleID, SpecNumber: nullSpecNumber, SRODate: false, SRONumber: false };
                  else ruleForWriteSROInfo[roleIndex] = { RoleID: roleID, SpecNumber: nullSpecNumber, SRODate: ruleForWriteSROInfo[roleIndex].SRODate, SRONumber: ruleForWriteSROInfo[roleIndex].SRONumber };
                }
              }
            }
          }
          else {
            let matchingRow = pedm.rows.find(x => x.get("RowID") === row.get("MatchingRowID"));
            if (matchingRow != null) {
              matchingRow.set("SpecialistNumber", null);
              if (matchingRow.has('RoleID')) {
                let roleID = matchingRow.tryGet('RoleID');
                if (roleID) {
                  let roleIndex = ruleForWriteSROInfo.findIndex(x => x.RoleID === roleID);
                  if (roleIndex < 0) ruleForWriteSROInfo[ruleForWriteSROInfo.length] = { RoleID: roleID, SpecNumber: true, SRODate: false, SRONumber: false };
                  else ruleForWriteSROInfo[roleIndex] = { RoleID: roleID, SpecNumber: true, SRODate: ruleForWriteSROInfo[roleIndex].SRODate, SRONumber: ruleForWriteSROInfo[roleIndex].SRONumber };
                }
              }
            }
          }
        }
      }
      if (e.removed.length > 0) {
        let row = e.removed[0];
        let matchingRow = pedm.rows.find(x => x.get("RowID") === row.get("MatchingRowID"));
        if (matchingRow != null) {
          matchingRow.set("SpecialistNumber", null);
          if (matchingRow.has('RoleID')) {
            let roleID = matchingRow.tryGet('RoleID');
            if (roleID) {
              let roleIndex = ruleForWriteSROInfo.findIndex(x => x.RoleID === roleID);
              if (roleIndex < 0) ruleForWriteSROInfo[ruleForWriteSROInfo.length] = { RoleID: roleID, SpecNumber: true, SRODate: false, SRONumber: false };
              else ruleForWriteSROInfo[roleIndex] = { RoleID: roleID, SpecNumber: true, SRODate: ruleForWriteSROInfo[roleIndex].SRODate, SRONumber: ruleForWriteSROInfo[roleIndex].SRONumber };
            }
          }
        }
      }
    });
  }

  /** Кнопка для создания/обновления шаблона акта */
  private static FileTemplateButtonLogic(card: Card, model: ICardModel) {
    let fileTemplateButton: IControlViewModel | undefined = model.controls.get('ButtonTemplateControl');
    let ediSection: CardSection | undefined = card.sections.tryGet('PkExecutiveDocumentationInfo');
    if (!fileTemplateButton || !ediSection) return;
    let edKindID: guid | undefined = ediSection.fields.tryGet('EDKindNewID');
    if (!edKindID) {
      ediSection.fields.set('EDKindNewID', createTypedField(null, DotNetType.Guid));
    }
    ediSection.fields.fieldChanged.add(e => {
      if (e.fieldName === 'EDKindNewID') {
        if (!fileTemplateButton) return;
        this.UpdateButtonControlVisability(fileTemplateButton, card);
      }
    });
    this.UpdateButtonControlVisability(fileTemplateButton, card);

    let button: ButtonViewModel = fileTemplateButton as ButtonViewModel;
    let templateFileRowID: guid | null = CdExecutiveDocumentationSharedHelper.GetCurrentTemplateFileRowID(card);
    let templateFile: CardFile | undefined = card.files.find(x => templateFileRowID != null && x.rowId === templateFileRowID);
    if (templateFile) {
      templateFile.stateChanged.add(e => {
        if (e.newState === CardFileState.Deleted) {
          this.UpdateButtonControlName(button, card, true);
        }
      });
    }
    this.UpdateButtonControlName(button, card);

    button.onClick = () => this.ActionFileTemplate();
  }

  /** Кнопка для создания/обновления шаблона акта */
  public static ItdBlockLogic(context: ICardUIExtensionContext) {
    let card: Card = context.card;
    let block = context.model.blocks.get("BlockItdApprove");
    if (!block) return;
    let ediSection: CardSection | undefined = card.sections.tryGet('PkExecutiveDocumentationInfo');

    let isVisible: boolean | undefined = ediSection && ediSection.fields.has("ItdProjectID") && ediSection.fields.tryGet('ItdProjectID') != null

    if (isVisible) {
      let pkEdInfo = context.model.card.sections.tryGet("PkExecutiveDocumentationInfo");
      if (!pkEdInfo) return;

      let packetId = pkEdInfo!.fields.get("PacketID");
      this.PacketLogic(context);

      // определяем обработчик нажатия на кнопку

      this.PacketVisibilityLogic(context, packetId != null);
      pkEdInfo.fields.fieldChanged.add(e => {
        if (e.fieldName == "PacketID") {
          this.PacketVisibilityLogic(context, e.fieldValue !== null);
        }
      });
    }

    block!.blockVisibility = isVisible ? Visibility.Visible : Visibility.Collapsed;
  }

  private static async PacketLogic(context: ICardUIExtensionContext) {
    var card = context.model.card;

    var addToPacketButton = context.model.controls.get("AddToPacketButton") as ButtonViewModel;
    var executiveDocumentationPacket = context.model.controls.get("ExecutiveDocumentationPacket") as GridViewModel;
    var packetIDTextBox = context.model.controls.get("PacketID") as TextBoxViewModel;

    if (addToPacketButton == null || executiveDocumentationPacket == null || packetIDTextBox == null) {
      return;
    }

    let pkediSection = card.sections.tryGet("PkExecutiveDocumentationInfo");
    let documentStatesAllowed = [ItdDocumentStates.NEW.ExtName, ItdDocumentStates.REVISION.ExtName]
    let itdDocumentStateExtName = pkediSection ? pkediSection!.fields.get("ItdDocumentStateExtName") : "";
    let packetReadonly = !documentStatesAllowed.some(x => x === itdDocumentStateExtName);

    executiveDocumentationPacket.isReadOnly = packetReadonly;

    executiveDocumentationPacket.rowInvoked.add(async e => {
      if (e.action == GridRowAction.Opening) {
        let cardId = e.row.get("CardID");
        await openCard({
          cardId: cardId,
        });
        e.cancel = true;
        return;
      }
      if (e.action == GridRowAction.Deleting) {
        let cardId: string = e.row.get("CardID");
        if (context.card.info["PacketCardsToDeleteIds"]) {
          let cardsList: string[] = context.card.info["PacketCardsToDeleteIds"].split(";");
          cardsList.push(cardId.toString());
          context.card.info["PacketCardsToDeleteIds"] = cardsList.join(";");
        }
        else {
          context.card.info["PacketCardsToDeleteIds"] = cardId.toString();
        }
        return;
      }
    });

    executiveDocumentationPacket.rowAdding.add(async e => {
      let model = context.model;
      let section = model.card.sections.tryGet("PkExecutiveDocumentationPacketVirtual");
      const refSection = "PkExecutiveDocumentation_PacketSelection";

      var departmentId = model.card.sections.tryGet("DocumentCommonInfo")!.fields.get("DepartmentID");
      var departmentName = model.card.sections.tryGet("DocumentCommonInfo")!.fields.get("DepartmentName");

      var objects = model.card.sections.tryGet("PkObjectsVirtual")!.fields.get("ObjectsLikeString");

      // let excc = section.rows. (x => x.Fields.TryGet<Guid?>("CardID") != null).Select(x => x.Fields.TryGet<Guid>("CardID")).ToList()
      // let excludeCards = "{\"ObjectsId\":" + JSON.stringify(mainObjects.ObjectsId) + "}";
      let excludeCards = "{\"ObjectsId\": [\"" + card.id + "\"]}";

      const deparmentIdParameter = new ViewParameterMetadata();
      deparmentIdParameter.alias = 'DepartmentAuthorId';
      deparmentIdParameter.caption = 'Организация автора';
      deparmentIdParameter.hidden = true;
      deparmentIdParameter.dataType = DbType.Guid;
      deparmentIdParameter.multiple = false;
      const deparmentNameParameter = new ViewParameterMetadata();
      deparmentNameParameter.alias = 'DepartmentAuthorName';
      deparmentNameParameter.caption = 'Организация автора';
      deparmentNameParameter.hidden = false;
      deparmentNameParameter.dataType = DbType.String;
      deparmentNameParameter.multiple = false;
      const objectsParameter = new ViewParameterMetadata();
      objectsParameter.alias = 'Objects';
      objectsParameter.caption = 'Объекты';
      objectsParameter.hidden = true;
      objectsParameter.dataType = DbType.String;
      objectsParameter.multiple = false;
      const excludeCardsParameter = new ViewParameterMetadata();
      excludeCardsParameter.alias = 'ExcludeCards';
      excludeCardsParameter.caption = 'Кроме';
      excludeCardsParameter.hidden = true;
      excludeCardsParameter.dataType = DbType.String;
      excludeCardsParameter.multiple = false;
      const isInPacket = new ViewParameterMetadata();
      isInPacket.alias = 'IsInPacket';
      isInPacket.caption = 'Входит в комплект';
      isInPacket.hidden = true;
      isInPacket.dataType = DbType.Boolean;
      isInPacket.multiple = false;

      const parameters = [
        new RequestParameterBuilder()
          .withMetadata(deparmentIdParameter)
          .addCriteria(equalsCriteriaOperator(), departmentId, departmentId)
          .asRequestParameter(),
        new RequestParameterBuilder()
          .withMetadata(deparmentNameParameter)
          .addCriteria(equalsCriteriaOperator(), departmentName, departmentName)
          .asRequestParameter(),
        new RequestParameterBuilder()
          .withMetadata(objectsParameter)
          .addCriteria(equalsCriteriaOperator(), objects, objects)
          .asRequestParameter(),
        new RequestParameterBuilder()
          .withMetadata(excludeCardsParameter)
          .addCriteria(equalsCriteriaOperator(), excludeCards, excludeCards)
          .asRequestParameter(),
        new RequestParameterBuilder()
          .withMetadata(excludeCardsParameter)
          .addCriteria(isFalseCriteriaOperator())
          .asRequestParameter()
      ];

      await showViewsDialog(
        refSection,
        async (value) => {
          if (!value) {
            return;
          }

          let selectedItem = value;
          if (selectedItem == null
            || !selectedItem.selectedRow
            || !section) {
            e.cancel = true;
            return;
          }

          let selectedRow = selectedItem.selectedRow;
          if (selectedRow == null) {
            e.cancel = true;
            return;
          }

          if (selectedRow.get("edID")) {
            let row = new CardRow();

            row.rowId = Guid.newGuid();

            CdCommonHelper.SetValueToRowField(row, "SecondaryFullNumber", selectedRow.get("SecondaryFullNumber"), DotNetType.String);
            CdCommonHelper.SetValueToRowField(row, "Number", selectedRow.get("FullNumber"), DotNetType.String);
            CdCommonHelper.SetValueToRowField(row, "CardID", selectedRow.get("edID"), DotNetType.Guid);
            CdCommonHelper.SetValueToRowField(row, "Date", selectedRow.get("DocDate"), DotNetType.DateTime);
            CdCommonHelper.SetValueToRowField(row, "StateID", selectedRow.get("StateID"), DotNetType.Int32);
            CdCommonHelper.SetValueToRowField(row, "StateName", selectedRow.get("StateName"), DotNetType.String);
            CdCommonHelper.SetValueToRowField(row, "Floor", selectedRow.get("FloorNumber"), DotNetType.String);
            CdCommonHelper.SetValueToRowField(row, "Section", selectedRow.get("SectionNumber"), DotNetType.String);
            CdCommonHelper.SetValueToRowField(row, "EDKindNewID", selectedRow.get("EDKindID"), DotNetType.Guid);
            CdCommonHelper.SetValueToRowField(row, "EDKindNewName", selectedRow.get("EDKindName"), DotNetType.String);
            CdCommonHelper.SetValueToRowField(row, "WorkLocation", selectedRow.get("WorkLocation"), DotNetType.String);
            CdCommonHelper.SetValueToRowField(row, "WorkTypeID", selectedRow.get("WorkTypeID"), DotNetType.Guid);
            CdCommonHelper.SetValueToRowField(row, "WorkTypeName", selectedRow.get("WorkTypeName"), DotNetType.String);
            CdCommonHelper.SetValueToRowField(row, "WorkTypeExtID", selectedRow.get("WorkTypeExtID"), DotNetType.String);
            CdCommonHelper.SetValueToRowField(row, "WorkKindID", selectedRow.get("EDTypeID"), DotNetType.Guid);
            CdCommonHelper.SetValueToRowField(row, "WorkKindWorkName", selectedRow.get("EDTypeName"), DotNetType.String);
            row.state = CardRowState.Inserted;
            section!.rows.push(row);
          }
        },
        parameters
      );
      e.cancel = true;
    });

    if (addToPacketButton != null) {
      addToPacketButton.isReadOnly = packetReadonly;

      addToPacketButton.onClick = () => {
        var pkDocumentCommonInfoSection = card.sections.tryGet("PkDocumentCommonInfo");
        var documentCommonInfoSection = card.sections.tryGet("DocumentCommonInfo");
        var pkExecutiveDocumentationInfo = card.sections.tryGet("PkExecutiveDocumentationInfo");
        var objectListSectionRow = card.sections.tryGet("PkObjectList")!.rows[0];

        var section = context.card.sections.getOrAdd("PkExecutiveDocumentationPacketVirtual");
        let row: CardRow = new CardRow();
        row.rowId = Guid.newGuid();

        if (!documentCommonInfoSection || !pkDocumentCommonInfoSection || !pkExecutiveDocumentationInfo) return;

        CdCommonHelper.SetValueToRowField(row, "SecondaryFullNumber", documentCommonInfoSection.fields.get("SecondaryFullNumber"), DotNetType.String);
        CdCommonHelper.SetValueToRowField(row, "Number", documentCommonInfoSection.fields.get("FullNumber"), DotNetType.String);
        CdCommonHelper.SetValueToRowField(row, "CardID", card.id, DotNetType.Guid);
        CdCommonHelper.SetValueToRowField(row, "Date", documentCommonInfoSection.fields.get("DocDate"), DotNetType.DateTime);
        CdCommonHelper.SetValueToRowField(row, "StateID", pkDocumentCommonInfoSection.fields.get("StateID"), DotNetType.Int32);
        CdCommonHelper.SetValueToRowField(row, "StateName", pkDocumentCommonInfoSection.fields.get("StateName"), DotNetType.String);
        CdCommonHelper.SetValueToRowField(row, "Floor", objectListSectionRow!.get("FloorNumber"), DotNetType.String);
        CdCommonHelper.SetValueToRowField(row, "Section", objectListSectionRow!.get("SectionNumber"), DotNetType.String);
        CdCommonHelper.SetValueToRowField(row, "EDKindNewID", pkExecutiveDocumentationInfo.fields.get("EDKindID"), DotNetType.Guid);
        CdCommonHelper.SetValueToRowField(row, "EDKindNewName", pkExecutiveDocumentationInfo.fields.get("EDKindName"), DotNetType.String);
        CdCommonHelper.SetValueToRowField(row, "WorkLocation", pkExecutiveDocumentationInfo.fields.get("WorkLocation"), DotNetType.String);
        CdCommonHelper.SetValueToRowField(row, "WorkTypeID", pkExecutiveDocumentationInfo.fields.get("WorkTypeID"), DotNetType.Guid);
        CdCommonHelper.SetValueToRowField(row, "WorkTypeName", pkExecutiveDocumentationInfo.fields.get("WorkTypeName"), DotNetType.String);
        CdCommonHelper.SetValueToRowField(row, "WorkTypeExtID", pkExecutiveDocumentationInfo.fields.get("WorkTypeExtID"), DotNetType.String);
        CdCommonHelper.SetValueToRowField(row, "WorkKindID", pkExecutiveDocumentationInfo.fields.get("EDTypeID"), DotNetType.Guid);
        CdCommonHelper.SetValueToRowField(row, "WorkKindWorkName", pkExecutiveDocumentationInfo.fields.get("EDTypeName"), DotNetType.String);

        row.state = CardRowState.Inserted;
        section!.rows.push(row);
        context.card.sections.tryGet("PkExecutiveDocumentationInfo")!.fields.set("PacketID", createTypedField(Guid.newGuid(), DotNetType.Guid));
        executiveDocumentationPacket.addRow();
      };
    }
  }

  private static async PacketVisibilityLogic(context: ICardUIExtensionContext, isPacket: boolean) {
    let addToPacketButton = context.model.controls.get("AddToPacketButton") as ButtonViewModel;
    let executiveDocumentationPacket = context.model.controls.get("ExecutiveDocumentationPacket") as GridViewModel;
    let itdPacketID = context.model.controls.get("ItdPacketID") as TextBoxViewModel;
    let packetIDTextBox = context.model.controls.get("PacketID") as TextBoxViewModel;

    if (addToPacketButton == null || executiveDocumentationPacket == null || itdPacketID == null || packetIDTextBox == null) {
      return;
    }

    executiveDocumentationPacket.controlVisibility = isPacket ? Visibility.Visible : Visibility.Collapsed;
    itdPacketID.controlVisibility = isPacket ? Visibility.Visible : Visibility.Collapsed;
    packetIDTextBox.controlVisibility = isPacket ? Visibility.Visible : Visibility.Collapsed;
    addToPacketButton.controlVisibility = (!isPacket) ? Visibility.Visible : Visibility.Collapsed;
  }

  /** Кнопка для создания/обновления шаблона акта */
  private static FileForPrintButtonLogic(card: Card, model: ICardModel) {
    let fileForPrintButton: IControlViewModel | undefined = model.controls.get('CreateFileForPrintControl');
    let ediSection: CardSection | undefined = card.sections.tryGet('PkExecutiveDocumentationInfo');
    if (!fileForPrintButton || !ediSection) return;
    ediSection.fields.fieldChanged.add(e => {
      if (e.fieldName === 'SigningTypeID') {
        if (!fileForPrintButton) return;
        this.UpdateButtonControlVisability(fileForPrintButton, card, false);
      }
    });
    this.UpdateButtonControlVisability(fileForPrintButton, card, false);

    let button: ButtonViewModel = fileForPrintButton as ButtonViewModel;
    let fileForPrint: CardFile | undefined = card.files.find(x =>
      x.categoryId !== null &&
      ChFileCategories.DocumentID.id !== null &&
      x.categoryId.toLowerCase() === ChFileCategories.DocumentID.id.toLocaleLowerCase() &&
      x.name.indexOf(this.PdfForPrint) > 0);
    if (fileForPrint) {
      fileForPrint.stateChanged.add(e => {
        if (e.newState === CardFileState.Deleted) {
          this.UpdateButtonControlName(button, card, true, false);
        }
      });
    }
    this.UpdateButtonControlName(button, card, false, false);

    button.onClick = () => this.ActionFileForPrint();
  }

  /** Логика кнопки создать/обновить шаблон акта */
  private static async ActionFileTemplate() {
    let context: IUIContext = UIContext.current;
    let editor: ICardEditorModel | null = context.cardEditor;
    if (!editor) return;
    let model: ICardModel | null = editor.cardModel;
    if (!model) return;
    let card: Card = model.card;
    let templateFileRowID: guid | null = CdExecutiveDocumentationSharedHelper.GetCurrentTemplateFileRowID(card);

    if (card.files.find(x => (templateFileRowID !== null && x.rowId === templateFileRowID)) !== undefined) {
      let dialogResult: boolean =
        card.hasChanges()
          ? confirm('Карточка имеет несохранённые данные.\nСохранить карточку и обновить шаблон акта?')
          : confirm('Обновить шаблон акта?');
      if (!dialogResult) return;
    }

    const storeInfo: IStorage = {
      'AddTemplateFile': createTypedField(true, DotNetType.Boolean)
    };
    await editor.saveCard(context, storeInfo);
  }

  /** Логика кнопки создать/обновить файл для печати #21763 */
  private static async ActionFileForPrint() {
    let context: IUIContext = UIContext.current;
    let editor: ICardEditorModel | null = context.cardEditor;
    if (!editor) return;
    let model: ICardModel | null = editor.cardModel;
    if (!model) return;
    let card: Card = model.card;

    let control = model.controls.get('CreateFileForPrintControl');
    if (!control) {
      return;
    }
    try {
      control.isReadOnly = false;

      let signedFile = card.files.find(x =>
        x.categoryId !== null &&
        ChFileCategories.DocumentID.id !== null &&
        x.categoryId.toLowerCase() === ChFileCategories.DocumentID.id.toLocaleLowerCase() &&
        !(x.name.indexOf(this.PdfForPrint) > 0));

      if (!signedFile ||
        !signedFile.lastVersion) {
        throw new Error('Не найден файл, для которого необходимо сформировать печатную форму');
      }

      const getFileContentRequest = new CardGetFileContentRequest();
      getFileContentRequest.fileTypeName = CdFileTypes.GetFileForPrintType;
      getFileContentRequest.cardId = card.id;
      getFileContentRequest.versionRowId = signedFile.lastVersion.rowId;
      getFileContentRequest.fileId = signedFile.rowId;
      getFileContentRequest.fileName = signedFile.name;

      const getFileContentResponse = await CardService.instance.getFileContent(getFileContentRequest);

      if (!getFileContentResponse.validationResult.isSuccessful) {
        throw new Error(getFileContentResponse.validationResult.build().toString());
      }

      if (getFileContentResponse.content == null ||
        getFileContentResponse.size === 0) {
        throw new Error('Не получен контент, файл пустой.');
      }

      if (!getFileContentResponse.validationResult.isSuccessful ||
        getFileContentResponse.content == null ||
        getFileContentResponse.size === 0) {
        return null;
      }

      let fileName: string = signedFile.name.substr(0, signedFile.name.lastIndexOf('.')) + this.PdfForPrint;
      let fileContent: File = new File([getFileContentResponse.content], fileName);

      card.files.forEach(x => {
        if (x.categoryId &&
          ChFileCategories.DocumentID.id &&
          x.categoryId.toLowerCase() === ChFileCategories.DocumentID.id.toLocaleLowerCase() &&
          x.name.indexOf(this.PdfForPrint) > 0) {
          x.state = CardFileState.Deleted;
        }
      });

      let fileForPrint: IFile = model.fileContainer.createFile(
        fileContent,
        CdFileTypes.DefaultFileType,
        ChFileCategories.DocumentID,
        fileName
      );
      await model.fileContainer.addFile(fileForPrint);
      await editor.saveCard(context);

      this.UpdateButtonControlName(control as ButtonViewModel, card, false, false);

    } catch (error) {

      showError('Ошибка в процессе формирования печатной формы акта: ' + error.toString());
      throw error;

    } finally {
      control.isReadOnly = false;
    }
  }

  /** Обновить видимость кнопки в файловом контроле */
  private static UpdateButtonControlVisability(control: IControlViewModel, card: Card, fromTemplateButton: boolean = true) {
    // Кнопка "Создать акт по шаблону"
    if (fromTemplateButton) {
      let dciSection: CardSection | undefined = card.sections.tryGet('PkDocumentCommonInfo');
      let ediSection: CardSection | undefined = card.sections.tryGet('PkExecutiveDocumentationInfo');
      if (!dciSection || !ediSection) {
        control.controlVisibility = Visibility.Collapsed;
        return;
      }
      let stateID: number | undefined = dciSection.fields.tryGet('StateID');
      let kindID: guid | undefined = ediSection.fields.tryGet('EDKindNewID');
      if (!stateID || !kindID) {
        control.controlVisibility = Visibility.Collapsed;
        return;
      }
      let correctStates: boolean = (stateID === CdDocStates.Draft.id || stateID === CdDocStates.Rework.id);
      let correctKinds: boolean = kindID === CdExecutiveDocumentationKinds.ActOfExaminationOfHiddenWorks
        || kindID === CdExecutiveDocumentationKinds.ActOfExaminationOfResponsibleStructures
        || kindID === CdExecutiveDocumentationKinds.ActOfIntermediateExaminationOfResponsibleStructures;

      if (correctStates && correctKinds) {
        if (control.controlVisibility !== Visibility.Visible) {
          control.controlVisibility = Visibility.Visible;
        }
      } else {
        if (control.controlVisibility !== Visibility.Collapsed) {
          control.controlVisibility = Visibility.Collapsed;
        }
      }
      // Кнопка "Сформировать печатную форму акта"
    } else {
      let dciSection: CardSection | undefined = card.sections.tryGet('PkDocumentCommonInfo');
      let ediSection: CardSection | undefined = card.sections.tryGet('PkExecutiveDocumentationInfo');
      if (!dciSection || !ediSection) {
        control.controlVisibility = Visibility.Collapsed;
        return;
      }
      let stateID: number | undefined = dciSection.fields.tryGet('StateID');
      let signingTypeID: number | undefined = ediSection.fields.tryGet('SigningTypeID');
      if (!stateID || !signingTypeID) {
        control.controlVisibility = Visibility.Collapsed;
        return;
      }
      let correctStates: boolean = stateID !== CdDocStates.Draft.id && stateID !== CdDocStates.Rework.id;
      let correctSigningType: boolean = signingTypeID === 1;

      if (correctStates && correctSigningType) {
        if (control.controlVisibility !== Visibility.Visible) {
          control.controlVisibility = Visibility.Visible;
        }
      } else {
        if (control.controlVisibility !== Visibility.Collapsed) {
          control.controlVisibility = Visibility.Collapsed;
        }
      }
    }
  }

  /** Обновить название кнопки в файловом контроле */
  private static UpdateButtonControlName(control: ButtonViewModel, card: Card, isDelete: boolean = false, fromTemplateButton: boolean = true) {
    // Кнопка "Создать акт по шаблону"
    if (fromTemplateButton) {
      if (isDelete) {
        let ediSection: CardSection | undefined = card.sections.tryGet('PkExecutiveDocumentationInfo');
        if (ediSection && ediSection.fields.has('TemplateFileRowID')) {
          ediSection.fields['TemplateFileRowID'] = null;
        }
      }

      let templateFileRowID: guid | null = CdExecutiveDocumentationSharedHelper.GetCurrentTemplateFileRowID(card);
      let file: CardFile | undefined = card.files.find(x => (templateFileRowID !== null && x.rowId === templateFileRowID));
      if (file !== undefined && !isDelete) {
        control.text = 'Обновить информацию в акте';
      } else {
        control.text = 'Создать акт по шаблону';
      }
      // Кнопка "Сформировать печатную форму акта"
    } else {
      let file = card.files.find(x =>
        x.categoryId !== null &&
        ChFileCategories.DocumentID.id !== null &&
        x.categoryId.toLowerCase() === ChFileCategories.DocumentID.id.toLocaleLowerCase() &&
        x.name.indexOf(this.PdfForPrint) > 0);
      let hasFile: boolean = file !== undefined;

      if (hasFile) {
        control.text = 'Обновить печатную форму акта';
      } else {
        control.text = 'Сформировать печатную форму акта';
      }
    }
  }

  /** Обновить видимость контролов работ */
  private static UpdateWorkControlsVisability(missingTechnicalDocumentation: boolean | undefined, workTextControl: IControlViewModel, workRefControl: IControlViewModel) {
    if (missingTechnicalDocumentation !== undefined &&
      missingTechnicalDocumentation)
      this.UpdateControlsVisability(workTextControl, workRefControl);
    else
      this.UpdateControlsVisability(workRefControl, workTextControl);
  }

  /** Включает первый контрол и выключает второй */
  private static UpdateControlsVisability(firstControl: IControlViewModel, secondControl: IControlViewModel) {
    if (firstControl.controlVisibility !== Visibility.Visible)
      firstControl.controlVisibility = Visibility.Visible;
    if (secondControl.controlVisibility !== Visibility.Collapsed)
      secondControl.controlVisibility = Visibility.Collapsed;
  }


  private static async UpdateVisibilityHiddenWorks(card: Card, model: ICardModel) {
    let hiddenWorkField = model.controls.get("HiddenWorkField");
    if (card.sections.has("PkExecutiveDocumentationInfo")) {
      let pedi = card.sections.get("PkExecutiveDocumentationInfo");
      let missingHiddenWorks: boolean = pedi!.fields.get("MissingHiddenWorks");

      if (missingHiddenWorks != null
        && missingHiddenWorks) {
        hiddenWorkField!.controlVisibility = Visibility.Visible;
      }
      pedi!.fields.fieldChanged.add(async e => {
        if (e.fieldValue != null && e.fieldName == "MissingHiddenWorks") {
          missingHiddenWorks = e.fieldValue;

          if (missingHiddenWorks != null
            && missingHiddenWorks) {
            hiddenWorkField!.controlVisibility = Visibility.Visible;
          }
          else if (!missingHiddenWorks) {
            hiddenWorkField!.controlVisibility = Visibility.Collapsed;
            if (pedi!.fields.get("HiddenWorksSafetyStructure") != null) {
              pedi!.fields.set("HiddenWorksSafetyStructure", null)
            }
          }
        }
      });
    }
  }
  private static async UpdateVisibilityCopiedSubject(card: Card, model: ICardModel) {
    let copiedFrom = model.controls.get("CopiedFrom");
    if (card.sections.has("PkExecutiveDocumentationInfo")) {
      let pedi = card.sections.get("PkExecutiveDocumentationInfo");
      let isCopied: boolean = pedi!.fields.get("isCopied");

      if (isCopied != null
        && isCopied) {
        copiedFrom!.controlVisibility = Visibility.Visible;
      }
      else if (isCopied == null || !isCopied) {
        copiedFrom!.controlVisibility = Visibility.Collapsed;
      }
      pedi!.fields.fieldChanged.add(async e => {
        if (e.fieldValue != null && e.fieldName == "isCopied") {
          isCopied = e.fieldValue;

          if (isCopied != null
            && isCopied) {
            copiedFrom!.controlVisibility = Visibility.Visible;
          }
          else if (!isCopied) {
            copiedFrom!.controlVisibility = Visibility.Collapsed;
            pedi!.fields.set("CopiedFromID", null);
            pedi!.fields.set("CopiedFromSubject", null);
          }
        }
      });
    }
  }
  private static async GetCard(cardId: DotNetType.Guid) {
    const request = new CardGetRequest();
    request.getMode = CardGetMode.ReadOnly;
    request.cardId = cardId;
    const response = await CardService.instance.get(request);
    if (response.validationResult.isSuccessful) {
      return response.card;
    }
    else {
      return null;
    }
  }
  private static async FillActFromIntermediateAct(mainCard: Card, context: ICardUIExtensionContext) {
    if (!mainCard.sections.has("PkExecutiveDocumentationInfo"))
      return;
    let mainPediSection = mainCard!.sections.get("PkExecutiveDocumentationInfo");

    if (!mainPediSection!.fields.has("CopiedFromID"))
      return;

    mainPediSection!.fields.fieldChanged.add(async e => {
      if (e.fieldName == "CopiedFromID" && e.fieldValue != null) {
        let copiedCardId = mainPediSection!.fields.get("CopiedFromID");

        if (copiedCardId == null)
          return;

        var copiedCard = await this.GetCard(copiedCardId);
        if (copiedCard == null)
          return;

        this.SetActFields(mainCard, copiedCard);
        this.SaveCardToUpdateFiles(context);
      }
    });
  }
  private static async SetActFields(mainCard: Card, copiedCard: Card) {

    let mainPedi = mainCard.sections.get("PkExecutiveDocumentationInfo");
    let copiedPedi = copiedCard.sections.get("PkExecutiveDocumentationInfo");

    let mainPdci = mainCard.sections.get("PkDocumentCommonInfo");
    let copiedPdci = copiedCard.sections.get("PkDocumentCommonInfo");

    let mainPedwft = mainCard.sections.get("PkExecutiveDocumentationWorksForTemplate");
    let copiedPedwft = copiedCard.sections.get("PkExecutiveDocumentationWorksForTemplate");

    let mainPedhwssi = mainCard.sections.get("PkExecutiveDocumentationHiddenWorksSafetyStructureInfo");
    let copiedPedhwssi = copiedCard.sections.get("PkExecutiveDocumentationHiddenWorksSafetyStructureInfo");

    let mainPedm = mainCard.sections.get("PkExecutiveDocumentationMatching");
    let copiedPedm = copiedCard.sections.get("PkExecutiveDocumentationMatching");

    let mainPedr = mainCard.sections.get("PkExecutiveDocumentationRoles");
    let copiedPedr = copiedCard.sections.get("PkExecutiveDocumentationRoles");

    let mainPedars = mainCard.sections.get("PkExecutiveDocumentationActOfResonsibleStructures");
    let copiedPedars = copiedCard.sections.get("PkExecutiveDocumentationActOfResonsibleStructures");

    mainPedi!.fields.set("SigningTypeID", copiedPedi!.fields.get("SigningTypeID"), DotNetType.Int32);
    mainPedi!.fields.set("SigningTypeName", copiedPedi!.fields.get("SigningTypeName"), DotNetType.String);
    mainPedi!.fields.set("EDTypeID", copiedPedi!.fields.get("EDTypeID"), DotNetType.Guid);
    mainPedi!.fields.set("EDTypeName", copiedPedi!.fields.get("EDTypeName"), DotNetType.String);
    mainPedi!.fields.set("Location", copiedPedi!.fields.get("Location"), DotNetType.String);
    mainPedi!.fields.set("StartWorkDate", copiedPedi!.fields.get("StartWorkDate"), DotNetType.DateTime);
    mainPedi!.fields.set("FinishWorkDate", copiedPedi!.fields.get("FinishWorkDate"), DotNetType.DateTime);
    mainPedi!.fields.set("NumberOfCopies", copiedPedi!.fields.get("NumberOfCopies"), DotNetType.Int32);
    mainPedi!.fields.set("isEO", copiedPedi!.fields.get("isEO"), DotNetType.Boolean);
    mainPedi!.fields.set("isAuthorSupervision", copiedPedi!.fields.get("isAuthorSupervision"), DotNetType.Boolean);
    mainPedi!.fields.set("isZOS", copiedPedi!.fields.get("isZOS"), DotNetType.Boolean);
    let isRVE = copiedPedi!.fields.get("SigniisRVEngTypeName");
    if (isRVE == null)
      isRVE = false;
    mainPedi!.fields.set("isRVE", isRVE, DotNetType.Boolean);
    mainPedi!.fields.set("WorksPerformedAccordingToProjectDocumentation", copiedPedi!.fields.get("WorksPerformedAccordingToProjectDocumentation"), DotNetType.String);
    mainPedi!.fields.set("MissingTechnicalDocumentation", copiedPedi!.fields.get("MissingTechnicalDocumentation"), DotNetType.Boolean);
    mainPedi!.fields.set("MissingHiddenWorks", copiedPedi!.fields.get("MissingHiddenWorks"), DotNetType.Boolean);
    mainPedi!.fields.set("HiddenWorksSafetyStructure", copiedPedi!.fields.get("HiddenWorksSafetyStructure"), DotNetType.String);
    mainPedi!.fields.set("ConfirmingDocuments", copiedPedi!.fields.get("ConfirmingDocuments"), DotNetType.String);
    mainPedi!.fields.set("WorksPerformedInAccordance", copiedPedi!.fields.get("WorksPerformedInAccordance"), DotNetType.String);
    mainPedi!.fields.set("SubsequentWorkIsAllowedTypeID", copiedPedi!.fields.get("SubsequentWorkIsAllowedTypeID"), DotNetType.Guid);
    mainPedi!.fields.set("SubsequentWorkIsAllowedTypeName", copiedPedi!.fields.get("SubsequentWorkIsAllowedTypeName"), DotNetType.String);
    mainPedi!.fields.set("WorksForTemplate", copiedPedi!.fields.get("WorksForTemplate"), DotNetType.String);
    mainPedi!.fields.set("WorkLocation", copiedPedi!.fields.get("WorkLocation"), DotNetType.String);
    mainPedi!.fields.set("ResidentialComplexID", copiedPedi!.fields.get("ResidentialComplexID"), DotNetType.Guid);
    mainPedi!.fields.set("RegionID", copiedPedi!.fields.get("RegionID"), DotNetType.Guid);

    mainPedars!.fields.set("PermittedEmployStructures", copiedPedars!.fields.get("PermittedEmployStructures"), DotNetType.String);
    mainPedars!.fields.set("PermittedEmployStructuresWithLoad", copiedPedars!.fields.get("PermittedEmployStructuresWithLoad"), DotNetType.Int32);
    mainPedars!.fields.set("PermittedFullLoad", copiedPedars!.fields.get("PermittedFullLoad"), DotNetType.String);

    mainPdci!.fields.set("Description", copiedPdci!.fields.get("Description"), DotNetType.String);

    if (copiedPedwft!.rows != null && copiedPedwft!.rows.length > 0) {
      copiedPedwft!.rows.forEach(row => {
        let mainRow = new CardRow();

        mainRow.rowId = Guid.newGuid();

        mainRow.set("WorkTechnicalDocumentationID", row.get("WorkTechnicalDocumentationID"), DotNetType.Guid);
        mainRow.set("WorkTechnicalDocumentationFullNumber", row.get("WorkTechnicalDocumentationFullNumber"), DotNetType.String);
        mainRow.set("RdDivision", row.get("RdDivision"), DotNetType.String);
        mainRow.set("ContractDivision", row.get("ContractDivision"), DotNetType.String);
        mainRow.set("Version", row.get("Version"), DotNetType.String);
        mainRow.set("Number", row.get("Number"), DotNetType.String);

        mainRow.state = CardRowState.Inserted;
        mainPedwft!.rows.push(mainRow);
      });
    }
    if (copiedPedhwssi!.rows != null && copiedPedhwssi!.rows.length > 0) {
      copiedPedhwssi!.rows.forEach(row => {
        let needInsertRow: boolean = true;
        for (let existingRow of mainPedhwssi!.rows) {
          if (row.get("SubjectID") == existingRow.get("SubjectID")) {
            needInsertRow = false;
            break;
          }
        }
        if (needInsertRow) {
          let mainRow = new CardRow();

          mainRow.rowId = Guid.newGuid();

          mainRow.set("SecondaryFullNumber", row.get("SecondaryFullNumber"), DotNetType.String);
          mainRow.set("СreationDate", row.get("СreationDate"), DotNetType.DateTime);
          mainRow.set("SubjectID", row.get("SubjectID"), DotNetType.Guid);
          mainRow.set("SubjectSubject", row.get("SubjectSubject"), DotNetType.String);
          mainRow.set("Author", row.get("Author"), DotNetType.String);
          mainRow.set("Department", row.get("Department"), DotNetType.String);
          mainRow.set("State", row.get("State"), DotNetType.String);

          mainRow.state = CardRowState.Inserted;
          mainPedhwssi!.rows.push(mainRow);
        }
      });
    }

    let guids: Array<FillMatching> = new Array<FillMatching>();
    if (copiedPedm!.rows != null && copiedPedm!.rows.length > 0) {
      for (let i = 0; i < copiedPedm!.rows.length; i++) {
        for (let j = 0; j < mainPedm!.rows.length; j++) {
          if (copiedPedm!.rows[i].get("RoleID") == mainPedm!.rows[j].get("RoleID")) {
            let guid = new FillMatching();
            guid.CopiedID = copiedPedm!.rows[i].get("RowID");
            guid.ID = mainPedm!.rows[j].get("RowID");
            guid.IsExists = false;

            guids.push(guid);

            mainPedm!.rows[j].set("RoleID", copiedPedm!.rows[i].get("RoleID"), DotNetType.Int32);
            mainPedm!.rows[j].set("RoleName", copiedPedm!.rows[i].get("RoleName"), DotNetType.String);
            //mainPedm!.rows[j].set("Result", copiedPedm!.rows[i].get("SubjectID"), DotNetType.String);
            //mainPedm!.rows[j].set("Date", copiedPedm!.rows[i].get("Date"), DotNetType.String);
            mainPedm!.rows[j].set("OrderNumber", copiedPedm!.rows[i].get("OrderNumber"), DotNetType.String);
            mainPedm!.rows[j].set("OrderDate", copiedPedm!.rows[i].get("OrderDate"), DotNetType.DateTime);
            mainPedm!.rows[j].set("LegalEntityID", copiedPedm!.rows[i].get("LegalEntityID"), DotNetType.Guid);
            mainPedm!.rows[j].set("LegalEntityExternalID", copiedPedm!.rows[i].get("LegalEntityExternalID"), DotNetType.Int64);
            mainPedm!.rows[j].set("LegalEntityName", copiedPedm!.rows[i].get("LegalEntityName"), DotNetType.String);
            mainPedm!.rows[j].set("Order", copiedPedm!.rows[i].get("Order"), DotNetType.Int32);

            //mainPedm!.rows[j].state = CardRowState.Inserted;
          }
        }
        for (let j = 0; j < copiedPedr!.rows.length; j++) {
          if (copiedPedm!.rows[i].get("RowID") == copiedPedr!.rows[j].get("MatchingRowID")) {
            guids.find(x => x.CopiedID == copiedPedm!.rows[i].get("RowID"))!.IsExists = true;
          }
        }
      }
    }
    if (copiedPedr!.rows != null && copiedPedr!.rows.length > 0) {
      for (let mainRow of mainPedr!.rows) {
        if (mainRow.get("RoleID") != null
          && guids.find(x => x.ID == mainRow.get("MatchingRowID")) != null) {
          guids.find(x => x.ID == mainRow.get("MatchingRowID"))!.IsExists = false;
        }
        else {
          mainRow.state = CardRowState.Deleted;
        }
      }
      copiedPedr!.rows.forEach(row => {
        if (guids.find(x => x.CopiedID == row.get("MatchingRowID"))!.IsExists) {
          let mainRow = new CardRow();

          mainRow.rowId = Guid.newGuid();

          mainRow.set("MatchingRowID", guids.find(x => x.CopiedID == row.get("MatchingRowID"))!.ID, DotNetType.Guid);
          mainRow.set("RoleID", row.get("RoleID"), DotNetType.Guid);
          mainRow.set("RoleName", row.get("RoleName"), DotNetType.String);
          mainRow.set("RoleKCKName", row.get("RoleKCKName"), DotNetType.String);
          mainRow.set("RoleKCKID", row.get("RoleKCKID"), DotNetType.Guid);
          mainRow.set("RoleKCKExternalID", row.get("RoleKCKExternalID"), DotNetType.Int64);

          mainRow.state = CardRowState.Inserted;
          mainPedr!.rows.push(mainRow);
        }
      });
    }
  }
  private static async FillObjectsLikeString(card: Card, model: ICardModel) {
    if (card.sections.has("PkObjectsVirtual")) {
      let pov = card.sections.get("PkObjectsVirtual");
      let rows = card.sections.get("PkObjectList")!.rows;
      let mainObjects: Objects = new Objects();
      mainObjects.ObjectsId = new Array<DotNetType.Guid>();
      for (let i = 0; i < rows.length; i++) {
        if (rows[i].get("ObjectID") == null)
          continue;
        mainObjects.ObjectsId.push(rows[i].get("ObjectID"));
      }
      if (pov!.fields.has("ObjectsLikeString")) {
        let objectslikeString = "{\"ObjectsId\":" + JSON.stringify(mainObjects.ObjectsId) + "}"
        pov!.fields.set("ObjectsLikeString", objectslikeString, DotNetType.String);
        pov!.clearChanges();
      }
      var polTable = model.controls.get("Objects") as GridViewModel;

      polTable!.rowInitializing.add(e => {
        if (e == null)
          return;
        rows.forEach(row => {
          row.fieldChanged.add(e1 => {
            if (e1 == null)
              return;
            let objects: Objects = new Objects();
            objects.ObjectsId = new Array<DotNetType.Guid>();
            for (let i = 0; i < rows.length; i++) {
              if (rows[i].get("ObjectID") == null)
                continue;
              objects.ObjectsId.push(rows[i].get("ObjectID"));
            }
            if (pov!.fields.has("ObjectsLikeString")) {
              let objectslikeString = "{\"ObjectsId\":" + JSON.stringify(objects.ObjectsId) + "}"
              pov!.fields.set("ObjectsLikeString", objectslikeString, DotNetType.String);
              pov!.clearChanges();
            }
          });
        });
      });
    }
  }
}